<app-header></app-header>
<!-- Add employees choice -->
<section class="employeesection" [hidden]="(!employeeList && !employeeWithCcpsStage1) || employeeWithCcpsStage1">
  <div class="container-fluid">
    <section id="employee-nolist">
      <div class="image-container col-sm-12">
        <img src="assets/images/employee_nolist.png">
      </div>
      <div class="text-container">
        <h3 *ngIf="title == 'employees'" class="header-txt text-center mt-4 mb-4">{{'add employee title' | translate}}
        </h3>
        <h3 *ngIf="title == 'business'" class="header-txt text-center mt-4 mb-4">{{'import business title' | translate}}
        </h3>
        <h3 *ngIf="title == 'bank'" class="header-txt text-center mt-4 mb-4">{{'import bank title' | translate}}</h3>
      </div>
      <div id="addEmployeeContainer" class="custom-container">
        <!-- <button id="submit_btn" class="btn btn-main2" data-toggle="modal" data-target="#addEmployeeModal">{{'Add Employee Details2' | translate}}</button> -->
        <!-- <button id="submit_btn" class="btn btn-main2" id="WithoutCcpsForm1">{{'Add Employee Details2' | translate}}</button> -->
        <button id="submit_btn" class="btn btn-main2 " (click)="withCcpsIdFormCall()">{{'Add Employee Details2' |
          translate}}</button>
        <button for="bulk-file-upload" class="btn btn-main2" data-toggle="modal" data-target="#bulkUpload">
          {{'Bulk Upload' | translate}}
        </button>
      </div>
    </section>
  </div>
  <!-- <app-onboarding-portal></app-onboarding-portal> -->
</section>
<!-- Add employees modal -->
<div class="modal fade" id="addEmployeeModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body">
        <h5 class="form-title text-center">{{'Add Employees' | translate}}</h5>
        <div class="form-container">
          <div class="image-container">
            <div class="child-container" id="WithCcpsForm1">
              <img src="assets/images/add_employee1.png">
              <h5 class="form-title text-center">{{'Employee with CCPS ID' | translate}}</h5>
            </div>
            <div class="line"></div>
            <!-- <div class="child-container" id="WithoutCcpsForm1">
              <img src="assets/images/bulk_employee.png">
              <h5 class="form-title text-center">{{'Employee without CCPS ID' | translate}}</h5>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Add employees with ccps modal -->
<!-- Add employees with ccps stage2 -->
<!-- success modal -->
<section class="modal-section2">
  <div class="modal fade" id="successModal" data-backdrop="true" data-keyboard="false" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="parent">
            <div class="image-container">
              <img src="assets/images/Link-sucsess.png" style="width: 50%;margin: 0 auto;display: block;">
            </div>
            <div class="text-container text-center">
              <h4 class="modal-header-txt">{{'linked Company with CCPS' | translate}}</h4>
              <p class="para-light">{{'linked company with CCPS message' | translate}}</p>
              <button id="submit_btn" class="btn btn-medium" data-dismiss="modal">{{'Done' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- success modal  end-->
<!-- employee list section -->
<section class="middle-section getstarted employe-list" [hidden]="employeeList || employeeWithCcpsStage1">
  <div class="container-fluid">
    <div class="initiale_sestion">
      <div class="head">
        <div class="d-flex">
          <a (click)="goback()"><i class="fa fa-angle-left"></i></a>
          <h4 class="form-title-sm">{{'Manage Employees' | translate}}</h4>
        </div>
        <div class="custom-container">
          <button for="bulk-file-upload" class="btn btn-main2 btn-blue" data-toggle="modal" data-target="#bulkUpload">{{'Bulk Upload' | translate}}</button>
          <!-- <input id="bulk-file-upload" type="file"/> -->
          <!-- <button id="submit_btn" class="btn btn-main2" data-toggle="modal" data-target="#addEmployeeModal">{{'Register a New Employee' | translate}}</button> -->
          <!-- <button  class="btn btn-main2" (click)="registerNewEmployee()">{{'Register a New Employee' | translate}}</button> -->
          <button class="btn btn-main2 btn-green" (click)="withCcpsIdFormCall()">{{'Register a New Employee' | translate}}</button>
          <!-- <button class="btn btn-main2 refresh-btn" (click)="refreshPage()">{{'Refresh' | translate}} <i class="fa-solid fa-arrows-rotate"></i></button> -->
        </div>
      </div>
      <div class="head_2">
        <div class="text-container">
          <button class="btn modalBtn" (click)="pendingEmpoyeeModal()">{{ pendingEmployeeCount }} {{'Employees Application Pending' | translate}}<i class="fa-solid fa-circle-exclamation"></i></button>
        </div>
      </div>
    </div>
    <div class="reportTable">
      <table id="tooltip-table" class="quarter_table employeeTable">
        <colgroup>
          <col span="1" class="slno">
          <!-- <col span="1" class="ccpsId"> -->
          <col span="1" class="name">
          <!-- <col span="1" class="designation"> -->
          <col span="1" class="cnamgsId">
          <col span="1" class="ccpsId">
          <col span="1" class="mobile">
          <col span="1" class="cnssStatus">
          <col span="1" class="cnamgsStatus">
          <col span="1" class="employeeStatus">
          <col span="1" class="action">
        </colgroup>
        <thead>
          <tr>
            <td colspan="100">
              <div class="search-container"><i class="fa-solid fa-magnifying-glass hide"></i><label class="ml-2"><input
                    placeholder="{{'Search employee' | translate}}" class="search_icon"
                    (keyup)="setFilteredEmployees($event)" (keydown)="setFilteredEmployees($event)"></label></div>
            </td>
          </tr>
          <tr>
            <th scope="col">{{'SL NO' | translate}}</th>
            <!-- <th scope="col">{{'CCPS ID' | translate}}</th> -->
            <th scope="col">{{'Name2' | translate}}</th>
            <th scope="col">{{'NIP Number' | translate}}</th>
            <!-- <th scope="col">{{'Designation' | translate}}</th> -->
            <th scope="col">{{'CNAMGS ID' | translate}}</th>
            <th scope="col">{{'CNSS ID' | translate}}</th>
            <th scope="col">{{'Mobile' | translate}}</th>

            <th scope="col">{{'CNSS Status' | translate}}</th>
            <th scope="col">{{'CNAMGS Status' | translate}}</th>
            <th scope="col">{{'Employee Status' | translate}}</th>
            <th scope="col">{{'Action' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <!--  <tr>
            <td class="search-mob" colspan="100">
              <div class="search-parent"><i class="fa-solid fa-magnifying-glass hide"></i><label><input placeholder="Search employee" class="search_icon"></label></div>
            </td>
          </tr> -->
          <tr *ngFor="let employee of getDisplayedData(); let i = index"
            [ngClass]="{'pending-employee' : employee.status == 0, 'rejected-employee' : employee.status == 4, 'inactive-employee' : employee.status == '7'}">
            <td data-label="SL NO">{{ i + 1}}</td>
            <!-- <td attr.data-label="{{'CCPS ID' | translate}}" *ngIf="employee.ccps_code">{{ employee.ccps_code }}</td>
            <td attr.data-label="{{'CCPS ID' | translate}}" *ngIf="!employee.ccps_code">--</td> -->
            <td data-label="Name">{{ employee.name }}</td>
            <td data-label="NIP Number">{{ employee.nip_number || '--' }}</td>
            <!-- <td data-label="Designation">{{ employee.designation }}</td> -->
            <td data-label="CNAMGS ID" class="my-class" *ngIf="employee.cnamgs">{{ employee.cnamgs }}</td>
            <td data-label="CNAMGS ID" class="my-class" *ngIf="!employee.cnamgs">--</td>
            <td attr.data-label="{{'CCPS ID' | translate}}" *ngIf="employee.cnss">{{ employee.cnss }}</td>
            <td attr.data-label="{{'CCPS ID' | translate}}" *ngIf="!employee.cnss">--</td>
            <td data-label="Mobile">{{ employee.mobile }}</td>

            <td data-label="CNSS Status">{{ employee.cnss_status_label | translate }}</td>
            <td data-label="CNAMGS Status">{{ employee.cnamgs_status_label | translate }}</td>
            <td data-label="Employee Status">{{ employee.hiring_status_label | translate }}</td>
            <td data-label="Action">
              <div class="action-container">
                <!-- <a (click)="showAddEmployee(employee.id, '4', employee.nif_number)" *ngIf="employee.status != 7"> <i class="fa-solid fa-pen-to-square" title="{{ 'Modify' | translate }}"></i></a> -->
                <a (click)="getEmployeeDetails(employee.id)"> <i class="fa-solid fa-eye"
                    title="{{ 'Add Salary Revise' | translate }}"></i></a>
                <!-- <a  (click)="resignHistory(employee.id)"> <i class="fa-solid fa-eye"></i></a> -->
                <!-- <a *ngIf="employee.status == 1" (click)="resignEmployee(employee)"><img src="assets/images/resignation.png" alt="cancel image" title="{{ 'Termination' | translate }}"></a> -->
                <!-- *ngIf="employee.status == 4" -->
                <a *ngIf="employee.status == 4" (click)="showAddEmployee(employee.uuid, employee.entity_type)"> <i
                    class="fa-solid fa-repeat" title="{{ 'Resubmit' | translate }}"></i></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <mat-paginator [length]="totalItems" class="container-fluid paginator-container" [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)">
  </mat-paginator>
</section>
<!-- Add employee resignation modal -->
<div class="modal fade" id="employeeResignModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
  role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body">
        <div class="parent-container">
          <h5 class="form-title text-center">{{'Employee Resignation' | translate}}</h5>
          <form id="employeeResignForm" [formGroup]="resignationForm" (ngSubmit)="onSubmitResign()">
            <div class="user-data-container">
              <div class="user-data" *ngIf="employeeDetail">
                <div class="child-container">
                  <label class="labeltxt-sm">{{'CCPS ID' | translate}}</label>
                  <h6>{{ employeeDetail.ccps_code }}</h6>
                </div>
                <div class="child-container">
                  <label class="labeltxt-sm">{{'Name' | translate}}</label>
                  <h6>{{ employeeDetail.name }}</h6>
                </div>
                <div class="child-container">
                  <label class="labeltxt-sm">{{'Company ID' | translate}}</label>
                  <h6>{{ employeeDetail.company_id }}</h6>
                </div>
                <div class="child-container">
                  <label class="labeltxt-sm">{{'Designation' | translate}}</label>
                  <h6>{{ employeeDetail.designation }}</h6>
                </div>
                <div class="child-container">
                  <label class="labeltxt-sm">{{'CNAMGS ID' | translate}}</label>
                  <h6>{{ employeeDetail.cnamgs }}</h6>
                </div>
                <div class="child-container">
                  <label class="labeltxt-sm">{{'CNSS ID' | translate}}</label>
                  <h6>{{ employeeDetail.cnss }}</h6>
                </div>
                <div class="child-container">
                  <label class="labeltxt-sm">{{'Mobile' | translate}}</label>
                  <h6>{{ employeeDetail.mobile }}</h6>
                </div>
              </div>
            </div>
            <div class="input-container text-center input-box-white" [owlDateTimeTrigger]="dt42">
              <label class="labeltxt-sm">{{'Select Date of Resignation' | translate}}</label>
              <div class="date-field">
                <input class="" readonly [owlDateTime]="dt42" [min]="startat" name="dob" [max]="todayDate"
                  formControlName="date_of_resignation">
                <div class="calendar input-group-prepend">
                  <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                </div>
              </div>
              <owl-date-time [pickerType]="'calendar'" #dt42></owl-date-time>
              <div *ngIf="rsubmitted && a.date_of_resignation.errors" class="invalid-feedback">
                <div *ngIf="a.date_of_resignation.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>
            <div class="input-container text-center input-box-white">
              <label class="labeltxt-sm text-center">{{'Reason for Resignation' | translate}}</label>
              <select type="text" name="reason_leaving" class="bootstrap-select text-center" formControlName="reason"
                (change)="setValidator($event)" [(ngModel)]="resignReason">
                <option value="null" disabled selected>{{'Please Select one' | translate}}</option>
                <option *ngFor="let id of resign_reason" value="{{ id.id }}">{{ id.name }}</option>
              </select>
              <div *ngIf="rsubmitted && a.reason.errors" class="invalid-feedback">
                <div *ngIf="a.reason.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>
            <div class="text-container" *ngIf="a.reason.value == 14">
              <textarea placeholder="{{'write reason here' | translate}}" formControlName="reason_type"></textarea>
              <div *ngIf="rsubmitted && a.reason_type.errors" class="invalid-feedback">
                <div *ngIf="a.reason_type.errors?.required" class="text-center">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>
            <div class="child-container mt-4 text-center"
              *ngIf="a.reason.value == 3 || a.reason.value == 4 || a.reason.value == 13">
              <label for="resign_reason_document" class="labeltxt text-center" *ngIf="a.reason.value == 3">{{'Upload death certificate' | translate}}<span class="mandatory" *ngIf="!resign_reason_document">*</span> <span
                  *ngIf="resign_reason_document" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
              <label for="id_death_document" class="labeltxt text-center"
                *ngIf="a.reason.value == 4 || a.reason.value == 13">{{'Upload Health Certificate resign' | translate}}<span class="mandatory" *ngIf="!resign_reason_document">*</span> <span
                  *ngIf="resign_reason_document" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
              <label for="resign_reason_document" class="file-upload-card labeltxt" id="death-cer-upload">
                <div class="custom-container UploadIcon" id="death-certificate-upload">
                  <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                  <i class="fa fa-upload " aria-hidden="true"></i>
                </div>
              </label>
              <input class="" id="resign_reason_document" type="file" data-target="resign_reason_document" hidden
                (change)="upload($event, 'idDeathDocument')">
              <a *ngIf="resign_reason_document" id="idDeathDocument" href="{{resign_reason_document}}" target="_blank"
                class="viewFile text-center">{{'Click to view File'|translate}}</a>
              <div *ngIf="rsubmitted && a.resign_reason_document.errors" class="invalid-feedback text-center m-0">
                <div class="text-danger pt-3" *ngIf="a.resign_reason_document.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>
            <button type="button" id="submit_btn" class="btn btn-medium" (click)="resignationModalOpen()">{{'Submit' | translate}}</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Add employees modal -->
<div class="modal fade" id="addEmployeeModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body">
        <h5 class="form-title text-center">{{'Add Employees' | translate}}</h5>
        <div class="form-container">
          <div class="image-container">
            <div class="child-container" id="WithCcpsForm1">
              <img src="assets/images/add_employee1.png">
              <h5 class="form-title text-center">{{'Employee with CCPS ID' | translate}}</h5>
            </div>
            <div class="line"></div>
            <div class="child-container" id="WithoutCcpsForm1">
              <img src="assets/images/bulk_employee.png">
              <h5 class="form-title text-center">{{'Employee without CCPS ID' | translate}}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Add employees with ccps modal -->
<div class="modal fade" id="employeeWithCcpsModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
  role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body">
        <div class="parent-container">
          <h5 class="form-title text-center m-0">{{"Kindly type one of these employee's ID" | translate}}</h5>
          <!-- <p class="para-light text-center header-text-employees">{{'Kindly provide your Tax Identification Number (NIF) to allow the system to automatically fetch your company’s information from official public databases (DGI, CNSS, CNAMGS).' | translate}}</p> -->

          <!-- <div class="text-container text-center mt-0">
            <h6 class="stage-header">{{'Step' | translate}} 1</h6>
            <div class="stage-container">
              <div class="stepper-wrapper">
                <div class="stepper-item active">
                  <div class="step-counter">1</div>
                </div>
                <div class="stepper-item">
                  <div class="step-counter">2</div>
                </div>
                <div class="stepper-item">
                  <div class="step-counter">3</div>
                </div>
              </div>
            </div>
          </div> -->

          <form id="employeeWithCcpsForm" [formGroup]="withCcpsForm" (ngSubmit)="onSubmitEmployeeStage1()">
            <div class="input-container input-box-white">
              <label class="labeltxt text-center">{{'N° NIP/CNIE/passport/Carte de séjour/Carte de réfugié' | translate}}</label>
              <input formControlName="ccpsid" type="text" maxlength="16" class="placeholder" name="ccps_id" placeholder="" [readonly]="showConfirmationQuestion" [disabled]="showConfirmationQuestion">
              <p class="note-small-text text-center">{{'Note: Please enter the ID without spaces.' | translate}}</p>
              <div *ngIf="isSubmitted && f.ccpsid.errors" class="invalid-feedback text-center">
                <div *ngIf="f.ccpsid.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="f.ccpsid.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>
            
            <button type="submit" id="submit_btn" class="btn btn-medium" *ngIf="!showConfirmationQuestion">{{'Proceed' | translate}}</button>

            <!-- <div class="no-id-section" *ngIf="!showConfirmationQuestion">
              <p class="no-id-text">{{'Don/t have an ID/s mentioned above?' | translate}} <span (click)="onNoIdClick()">{{'Click here' | translate}}</span></p>
            </div> -->

          </form>

          <div *ngIf="showConfirmationQuestion" class="confirmation-question">
            <div class="confirmation-message text-center">
              <h5 class="form-title-sm text-center mb-2">{{'Are you' | translate}} {{nifNumberEmployeeName}}?</h5>
              <p class="para-light text-center mb-4 header-text-employees">{{'Please verify that the employee name displayed above matches the employee you wish to register. This confirmation ensures the accuracy of employee information and helps prevent any errors in the registration process.' | translate}}</p>
              <div class="confirmation-buttons mt-4">
                <button type="button" class="btn btn-medium no-btn mr-2" (click)="onConfirmationNo()">{{'No' | translate}}</button>
                <button type="button" class="btn btn-medium" (click)="onConfirmationYes()">{{'Yes, proceed' | translate}}</button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Add employees with ccps stage1 -->
<div class="verify-outer-bg-div" [hidden]="!employeeWithCcpsStage1">
  <form id="WithCcpsStage1Form" [formGroup]="CcpsStage1Form" (ngSubmit)="onSubmitEmployeeStage2()" class="w-100">

    


    <!-- Wrapper for all verification sections - Show all sections initially -->
    <div class="verify-inner-box-div group-verify-bg">
      <button class="back-btn-verify" (click)="gobacklist()"><img src="assets/images/back-arrow.png" alt=""></button>

      <div class="head-section-verify mb-3">
        <h5 class="company-title ">{{employeeHasNoId ? ((g.first_name.value && g.last_name.value) ? (g.first_name.value + ' ' + g.last_name.value) : ('Employee name' | translate)) : (nifNumberEmployeeName | translate)}}</h5>
        <p class="label-txt" *ngIf="!employeeHasNoId">{{'N° NIP/CNIE/passport/Carte de séjour/Carte de réfugié' | translate}} :
          <span>{{employeeNifNumber}}</span></p>
        <p class="label-txt" *ngIf="employeeHasNoId">{{'N° NIP/CNIE/passport/Carte de séjour/Carte de réfugié' | translate}} : <span>—</span></p>
      </div>
      <div class="rejected-reason-section2" *ngIf="employeeData?.reason " >
        <h5>{{"Reason for rejection" | translate}}</h5>
        <p class="reason bold">{{"Rejected by" | translate}} : <span> {{employeeData?.rejected_by | translate}}</span></p>
        <p class="reason bold" *ngIf="employeeData?.cnss_rejected_date">{{"CNSS Rejected on" | translate}} : <span> {{employeeData?.cnss_rejected_date | translate}}</span></p>
        <p class="reason bold" *ngIf="employeeData?.cnamgs_rejected_date">{{"CNAMGS Rejected on" | translate}} : <span> {{employeeData?.cnamgs_rejected_date | translate}}</span></p>
        <p class="reason bold" *ngIf="employeeData?.cnss_rejected_reason">{{"CNSS Reason" | translate}} : <span> {{employeeData?.cnss_rejected_reason | translate}}</span></p>
        <p class="reason bold" *ngIf="employeeData?.cnamgs_rejected_reason">{{"CNAMGS Reason" | translate}} : <span> {{employeeData?.cnamgs_rejected_reason | translate}}</span></p>
        <!-- <p class="reason">{{employeeData?.reason | translate}}</p> -->
      </div>

      <!-- CNSS and CNAMGS verification question sections - Always visible -->
      <div class="display-flex-center-div">
        <!-- CNSS Registration Question Card - Hide if CNAMGS No is selected -->
        <div class="verify-inner-box-div" *ngIf="!isCNSSSectionValue && !hideCnssSection && !isCnssEmployeeRegistrationFlow && !isCnamgsEmployeeRegistrationFlow">
          <div class="cnss-yes-no-section">
            <div class="head-section-verify">
              <h5 class="verify-title mb-2">{{'CNSS verification2' | translate}}</h5>
            </div>
            <div class="display-flex-head-mobile">
              <div class="label-img-div"><img src="assets/images/CNSS-logo-col.png" alt="" class="img-fluid"> </div>
            </div>
            <div class="radio-box-section">
              <div class="radio-box-container">
                <p class="radio-box-title">{{'Are22' | translate}} {{employeeHasNoId ? ((g.first_name.value && g.last_name.value) ? (g.first_name.value + ' ' + g.last_name.value) : ('Employee name' | translate)) : nifNumberEmployeeName}} {{'registered with CNSS ?'
                  | translate}}</p>
                <div class="checkbox-group">
                  <mat-radio-group formControlName="is_registered_cnss" class="mat-radio-btn"
                    (change)="onCNSSRegistrationChange()">
                    <mat-radio-button [value]="'yes'">{{ 'Yes' | translate
                      }}</mat-radio-button>
                    <mat-radio-button [value]="'no'">{{ 'No' | translate }}</mat-radio-button>
                  </mat-radio-group>
                </div>

                <div class="input-div mt-1" *ngIf="g.is_registered_cnss.value === 'yes'">
                  <div class="input-box-white">
                    <p class="labeltxt text-center">{{'N CNSS' | translate}} <span class="mandatory">*</span></p>
                    <input type="text" name="cnss_id" id="cnss" formControlName="cnss" maxlength="13"
                      (input)="formatCNSS($event)" placeholder="{{'Enter CNSS number' | translate}}">
                    <p class="note-small-text">{{'Note: Please enter the CNSS without spaces.' | translate}}</p>
                  </div>

                  <div *ngIf="isSubmit && g.cnss.errors" class="invalid-feedback">
                    <div *ngIf="g.cnss.errors?.required">{{'This field is mandatory'|translate}}</div>
                    <div *ngIf="g.cnss.errors?.pattern">{{'This field should be valid'|translate}}</div>
                  </div>
                </div>

                <!-- Show "No" message if CNSS No is selected -->
                <div class="rejected-reason-section mt-3" *ngIf="g.is_registered_cnss.value === 'no'">

                  <p class="reason">{{'You have selected that you are not registered with CNSS. Employee registration cannot proceed without CNSS registration.' | translate}}</p>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="verify-inner-box-div" *ngIf="isCNSSSectionValue && !hideCnssSection">
       

          <div class="display-flex-head-mobile">
            <div class="label-img-div"><img src="assets/images/CNSS-logo-col.png" alt="" class="img-fluid"> </div>
          </div>

          <div class="cnss-number-display-section">
            <p class="cnns-display-text">{{'CNSS Number2' | translate}} : <span>{{employeeData.cnss}}</span></p>
          </div>
        </div>

        <!-- CNAMGS Registration Question Card - Show when CNSS is not "no" -->
        <div id="cnamgs-registration-section" class="verify-inner-box-div"
          *ngIf="!isCnamgsSectionValue && !hideCnamgsSection && !isCnssEmployeeRegistrationFlow && !isCnamgsEmployeeRegistrationFlow">
          <div class="cnss-yes-no-section">
            <div class="head-section-verify">
              <h5 class="verify-title mb-2">{{'CNAMGS verification' | translate}}</h5>
            </div>
            <div class="display-flex-head-mobile">
              <div class="label-img-div"><img src="assets/images/cnamgslogo.png" alt="" class="img-fluid"> </div>
            </div>
            <div class="radio-box-section">
              <div class="radio-box-container">
                <p class="radio-box-title">{{'Are22' | translate}} {{employeeHasNoId ? ((g.first_name.value && g.last_name.value) ? (g.first_name.value + ' ' + g.last_name.value) : ('Employee name' | translate)) : nifNumberEmployeeName}} {{'registered with CNAMGS ?' | translate}}</p>
                <div class="checkbox-group">
                  <mat-radio-group formControlName="is_registered_cnamgs" class="mat-radio-btn"
                    (change)="onCNAMGSRegistrationChange()">
                    <mat-radio-button [value]="'yes'">{{ 'Yes' | translate
                      }}</mat-radio-button>
                    <mat-radio-button [value]="'no'">{{ 'No' | translate }}</mat-radio-button>
                  </mat-radio-group>
                </div>

                <div class="input-div mt-1" *ngIf="g.is_registered_cnamgs.value === 'yes'">
                  <div class="input-box-white">
                    <p class="labeltxt text-center">{{'N CNAMGS' | translate}} <span class="mandatory">*</span></p>
                    <input type="text" name="cnamgs_id" id="cnamgs" formControlName="cnamgs" maxlength="15"
                      (input)="formatCNAMGS($event)" placeholder="{{'Enter CNAMGS number' | translate}}">
                    <p class="note-small-text">{{'Note: Please enter the CNAMGS without spaces.' | translate}}</p>
                  </div>

                  <div *ngIf="isSubmit && g.cnamgs.errors" class="invalid-feedback">
                    <div *ngIf="g.cnamgs.errors?.required">{{'This field is mandatory'|translate}}</div>
                    <div *ngIf="g.cnamgs.errors?.pattern || g.cnamgs.errors?.invalidCnamgsFormat">{{'This field should be valid'|translate}}</div>
                  </div>
                </div>

                <!-- Show "No" message if CNAMGS No is selected -->
                <div class="rejected-reason-section mt-3" *ngIf="g.is_registered_cnamgs.value === 'no'">

                  <p class="reason">{{'You have selected that you are not registered with CNAMGS. Employee registration cannot proceed without CNAMGS registration.' | translate}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="verify-inner-box-div " *ngIf="isCnamgsSectionValue && !hideCnamgsSection">
          <div class="display-flex-head-mobile">
            <div class="label-img-div"><img src="assets/images/cnamgslogo.png" alt="" class="img-fluid"> </div>
          </div>
          <div class="cnss-number-display-section">
            <p class="cnns-display-text">{{'CNAMGS Number2' | translate}} : <span>{{employeeData.cnamgs}}</span>
            </p>
          </div>
        </div>
      </div>

      <!-- Submit button shown when form sections are hidden (when "No" is selected) -->
      <!-- Show hiring form submit button when "No" is selected (only in hiring flow) -->
      <div class="nif-btn-submit-div text-center" *ngIf="hideFormSectionsOnNo && !isCnssEmployeeRegistrationFlow && !isCnamgsEmployeeRegistrationFlow">
        <button type="button" class="btn btn-medium"
          (click)="onSubmitEmployeeStage2()">{{'Submit'|translate}}</button>
      </div>
      
      <!-- Show hiring form only when BOTH CNSS and CNAMGS are "yes" in hiring flow (not in registration flows) -->
      <div id="cnamgs-yes-form-section" class="verify-inner-box-div text-input-left"
        *ngIf="g.is_registered_cnss.value === 'yes' && g.is_registered_cnamgs.value === 'yes' && !hideFormSectionsOnNo && !isCnssEmployeeRegistrationFlow && !isCnamgsEmployeeRegistrationFlow">
        <div class="employer-manager-details-section">
          <div class="display-flex-head-mobile mb-5">
            <h2 class="text-center mb-0">{{'Employee Details' | translate}}</h2>
          </div>
          <div class="form-grid-group">
            <!-- First name and Last name - shown only for no-ID Hiring flow, inside Employee Details form -->
            <div class="input-div" *ngIf="employeeHasNoId">
              <div class="input-box-white">
                <p class="labeltxt">{{'First name' | translate}}<span class="mandatory">*</span></p>
                <input type="text" name="first_name" formControlName="first_name" maxlength="40" placeholder="{{'Enter First name' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.first_name.errors" class="invalid-feedback">
                <div *ngIf="g.first_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.first_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>
            <div class="input-div" *ngIf="employeeHasNoId">
              <div class="input-box-white">
                <p class="labeltxt">{{'Last name' | translate}}<span class="mandatory">*</span></p>
                <input type="text" name="last_name" formControlName="last_name" maxlength="40" placeholder="{{'Enter Last name' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.last_name.errors" class="invalid-feedback">
                <div *ngIf="g.last_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.last_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Hiring Date' | translate}}<span class="mandatory">*</span></p>
                <div [owlDateTimeTrigger]="dtCnamgsHiring" class="date-field">
                  <input type="text" [owlDateTime]="dtCnamgsHiring" [min]="minJoinDate" [max]="todayDate" readonly
                    name="joindate" formControlName="joindate" maxlength="100"
                    placeholder="{{'Enter Hiring Date' | translate}}">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dtCnamgsHiring></owl-date-time>
              </div>

              <div *ngIf="isSubmit && g.joindate.errors" class="invalid-feedback">
                <div *ngIf="g.joindate.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.joindate.errors?.pattern">{{'This field should be valid'|translate}}
                </div>
              </div>
            </div>

            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Hiring Certificate Date' | translate}}</p>
                <div [owlDateTimeTrigger]="dtCnamgsHiringCert" class="date-field">
                  <input type="text" [max]="todayDate" [owlDateTime]="dtCnamgsHiringCert" readonly
                    name="hiring_certificate_date" formControlName="hiring_certificate_date" maxlength="100"
                    placeholder="{{'Enter Hiring Certificate Date' | translate}}">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dtCnamgsHiringCert></owl-date-time>
              </div>
            </div>

            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Type of Contract' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="type_of_contract" formControlName="type_of_contract"
                  (change)="onContractTypeChange($any($event.target).value)" maxlength="100">
                  <option value="" disabled>{{'Please Select Type of Contract' | translate}}</option>
                  <option *ngFor="let item of contract" [value]="item.id">{{item.contract_type | translate}}</option>
                </select>
              </div>

              <div *ngIf="isSubmit && g.type_of_contract.errors" class="invalid-feedback">
                <div *ngIf="g.type_of_contract.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>

            <div class="input-div" *ngIf="g.type_of_contract.value === '2'">
              <div class="input-box-white">
                <p class="labeltxt ">{{'End Date' | translate}}<span class="mandatory">*</span></p>
                <div [owlDateTimeTrigger]="dtCnamgsContractEnd" class="date-field">
                  <input type="text" [max]="todayDate" [owlDateTime]="dtCnamgsContractEnd" readonly
                    name="contract_end_date" formControlName="contract_end_date" maxlength="100"
                    placeholder="{{'Enter End Date' | translate}}">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dtCnamgsContractEnd></owl-date-time>
              </div>

              <div *ngIf="isSubmit && g.contract_end_date.errors" class="invalid-feedback">
                <div *ngIf="g.contract_end_date.errors?.required">{{'This field is mandatory'|translate}}
                </div>
              </div>
            </div>

            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Professional Rank' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="professional_rank" formControlName="professional_rank" maxlength="100">
                  <option [value]="null" [selected]="!g.professional_rank.value" disabled>{{'Please Select Professional Rank' | translate}}</option>
                  <option *ngFor="let rank of professionalRankList" [value]="rank.id">{{rank.name | translate}}</option>
                </select>
              </div>

              <div *ngIf="isSubmit && g.professional_rank.errors" class="invalid-feedback">
                <div *ngIf="g.professional_rank.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>

            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Employee Type' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="employee_type" formControlName="employee_type"
                  (change)="onEmployeeTypeChange($any($event.target).value)" maxlength="100">
                  <option value="" disabled>{{'Please Select Employee Type' | translate}}</option>
                  <option *ngFor="let empType of employeeTypeList" [value]="empType.id">{{empType.name | translate}}
                  </option>
                </select>
              </div>

              <div *ngIf="isSubmit && g.employee_type.errors" class="invalid-feedback">
                <div *ngIf="g.employee_type.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>

            <div class="input-div" *ngIf="g.employee_type.value === '7'">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Please specify Employee Type' | translate}}<span class="mandatory">*</span></p>
                <input type="text" name="employee_type_other" formControlName="employee_type_other" maxlength="100" placeholder="{{'Please specify' | translate}}">
              </div>

              <div *ngIf="isSubmit && g.employee_type_other.errors" class="invalid-feedback">
                <div *ngIf="g.employee_type_other.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.employee_type_other.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Occupation / Position' | translate}}</p>
                <input type="text" name="position" formControlName="position" maxlength="100"
                  placeholder="{{'Enter Occupation / Position' | translate}}">
              </div>

              <div *ngIf="isSubmit && g.position.errors" class="invalid-feedback">
                <div *ngIf="g.position.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

          </div>

          <div class="nif-btn-submit-div text-center ">
            <button type="button" class="btn btn-medium" (click)="showModalCNAMGS()">{{'Submit'|translate}}</button>
          </div>
        </div>
      </div>
      <!-- CNAMGS "No" Comprehensive Form Card - Hide in hiring flow, only show in CNAMGS registration flow -->
      <!-- CNAMGS Registration Form - Only show in CNAMGS registration flow -->
      <div class="verify-inner-box-div text-input-left cnss-cnamgs-registeration"
        *ngIf="isCnamgsEmployeeRegistrationFlow">
        <div class="employer-manager-details-section">
          <div class="display-flex-head-mobile mb-5">
            <h2 class="text-center mb-0">{{'CNAMGS Registration' | translate}}</h2>
          </div>

          <!-- <div class="sub-section-with-line mb-3">
                      <div class="container mt-5">
                        <h6 class="">{{'CNAMGS Registration details' | translate}}<span class="mandatory" >*</span></h6>
                      </div>
                      <div class="line"></div>
                  </div> -->

          <div class="form-grid-group">
            <!-- First name and Last name - shown only for no-ID CNAMGS flow -->
            <div class="input-div" *ngIf="employeeHasNoId">
              <div class="input-box-white">
                <p class="labeltxt">{{'First name' | translate}}<span class="mandatory">*</span></p>
                <input type="text" name="first_name" formControlName="first_name" maxlength="40" placeholder="{{'Enter First name' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.first_name.errors" class="invalid-feedback">
                <div *ngIf="g.first_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.first_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>
            <div class="input-div" *ngIf="employeeHasNoId">
              <div class="input-box-white">
                <p class="labeltxt">{{'Last name' | translate}}<span class="mandatory">*</span></p>
                <input type="text" name="last_name" formControlName="last_name" maxlength="40" placeholder="{{'Enter Last name' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.last_name.errors" class="invalid-feedback">
                <div *ngIf="g.last_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.last_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>
            <!-- Photo - Mandatory -->
            <div class="input-div birthdetails-section">
              <div class="input-box-white employee-form-img">
                <p class="labeltxt ">{{'Photo' | translate}}<span class="mandatory">*</span> <span
                    *ngIf="employee_Photo" class="ml-1"><i class="fa fa-check-circle"></i></span></p>
                <label for="employee_Photo" class="file-upload-card labeltxt">
                  <div class="custom-container UploadIcon">
                    <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                    <i class="fa fa-upload " aria-hidden="true"></i>
                  </div>
                </label>
                <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
                <input class="" id="employee_Photo" type="file" formControlName="imageFile" hidden
                  (change)="upload($event, 'employeePhoto')" data-target="employee_Photo">
                <a *ngIf="employee_Photo" id="employee_Photo" href="{{employee_Photo}}" target="_blank"
                  class="viewFile text-center">{{'Click to view File'|translate}}</a>
              </div>
              <div *ngIf="isSubmit && g.employee_Photo.errors" class="invalid-feedback">
                <div *ngIf="g.employee_Photo.errors.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.employee_Photo.errors.size">{{'File Size should not be grater than 10 MB.'|translate}}
                </div>
              </div>
            </div>

            <!-- Gender - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Gender' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="gender" class="bootstrap-select" formControlName="gender"
                  [(ngModel)]="employeeGender" (change)="genderChange($event.target.value)">
                  <option [ngValue]="null" disabled>{{'Please Select one' | translate}}
                  </option>
                  <option [ngValue]="'1'"> {{'Male' | translate}}</option>
                  <option [ngValue]="'2'"> {{'Female' | translate}} </option>
                </select>
              </div>
              <div *ngIf="isSubmit && g.gender.errors" class="invalid-feedback">
                <div *ngIf="g.gender.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>
            <!-- Maiden Name - Optional, shown only if employee is female -->
            <div class="input-div" *ngIf="employeeGender == 2">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Maiden Name' | translate}}</p>
                <input type="text" name="maiden_name" formControlName="maiden_name" maxlength="40"
                  placeholder="{{'Enter Maiden Name' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.maiden_name.errors" class="invalid-feedback">
                <div *ngIf="g.maiden_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>
            <!-- ID Proof Type - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'ID Proof Type' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="Identity Document" class="bootstrap-select" formControlName="id_type"
                  [(ngModel)]="selectedValue">
                  <option [ngValue]="null" disabled>{{'Please Select one' | translate}}
                  </option>
                  <option *ngFor="let idType of idtypelist" [ngValue]="idType.id">{{idType.name | translate}}</option>
                </select>
              </div>
              <div *ngIf="isSubmit && g.id_type.errors" class="invalid-feedback">
                <div *ngIf="g.id_type.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>

            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Fingerprints' | translate}}</p>
                <div *ngIf="fingerprintsData" class="mt-2">
                  <img [src]="fingerprintsData" alt="Fingerprints" class="facial-biometrics-image">
                </div>
                <div *ngIf="!fingerprintsData" class="rejected-reason-section mt-2">
                  <p class="reason mb-0">{{'Didn\'t get the fingerprints details from DGI' | translate}}</p>
                </div>
              </div>
            </div>

            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Facial Biometrics' | translate}}</p>
                <div *ngIf="facialBiometricsData" class="mt-2">
                  <img [src]="facialBiometricsData" alt="Facial Biometrics" class="facial-biometrics-image">
                </div>
                <div *ngIf="!facialBiometricsData" class="rejected-reason-section mt-2">
                  <p class="reason mb-0">{{'Didn\'t get the facial biometrics details from DGI' | translate}}</p>
                </div>
              </div>
            </div>



            <!-- Father's First Name - Optional -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Father\'s First Name' | translate}}</p>
                <input type="text" name="first_father_name" formControlName="first_father_name" maxlength="40"
                  placeholder="{{'Enter Father\'s First Name' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.first_father_name.errors" class="invalid-feedback">
                <div *ngIf="g.first_father_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Father's Last Name - Optional -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Father\'s Last Name' | translate}}</p>
                <input type="text" name="last_father_name" formControlName="last_father_name" maxlength="40"
                  placeholder="{{'Enter Father\'s Last Name' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.last_father_name.errors" class="invalid-feedback">
                <div *ngIf="g.last_father_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Mother's First Name - Optional -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Mother\'s First Name' | translate}}</p>
                <input type="text" name="first_mother_name" formControlName="first_mother_name" maxlength="40"
                  placeholder="{{'Enter Mother\'s First Name' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.first_mother_name.errors" class="invalid-feedback">
                <div *ngIf="g.first_mother_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Mother's Last Name - Optional -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Mother\'s Last Name' | translate}}</p>
                <input type="text" name="last_mother_name" formControlName="last_mother_name" maxlength="40"
                  placeholder="{{'Enter Mother\'s Last Name' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.last_mother_name.errors" class="invalid-feedback">
                <div *ngIf="g.last_mother_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>



            <!-- Birth Details Section -->
            <div class="sub-section-with-line mb-3 birthdetails-section">
              <div class="mt-3">
                <h6 class="">{{'Birth Details' | translate}}</h6>
              </div>
              <div class="line"></div>
            </div>

            <!-- Date of Birth - Mandatory -->
            <div class="input-div" [owlDateTimeTrigger]="dt43">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Date of Birth' | translate}}<span class="mandatory">*</span></p>
                <div class="date-field">
                  <input class="" [max]="maxDateOfBirth" [min]="minDobDate" [owlDateTime]="dt43" name="dob"
                    formControlName="dob" placeholder="{{'Enter Date of Birth' | translate}}">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dt43></owl-date-time>
              </div>
              <div *ngIf="isSubmit && g.dob.errors" class="invalid-feedback">
                <div *ngIf="g.dob.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>

            <!-- Region - Mandatory (Birth Location) -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Region' | translate}}<span class="mandatory">*</span></p>
                <input type="text" name="birth_region" formControlName="birth_region" maxlength="40"
                  placeholder="{{'Enter Region' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.birth_region.errors" class="invalid-feedback">
                <div *ngIf="g.birth_region.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.birth_region.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- City - Mandatory (Birth Location) -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'City2' | translate}}</p>
                <input type="text" name="birth_city" formControlName="birth_city" maxlength="40"
                  placeholder="{{'Enter City' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.birth_city.errors" class="invalid-feedback">
                <div *ngIf="g.birth_city.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.birth_city.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- District - Mandatory (Birth Location) -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'District2' | translate}}</p>
                <input type="text" name="birth_district" formControlName="birth_district" maxlength="40"
                  placeholder="{{'Enter District' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.birth_district.errors" class="invalid-feedback">
                <div *ngIf="g.birth_district.errors?.required">{{'This field is mandatory'|translate}}
                </div>
                <div *ngIf="g.birth_district.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Neighborhood - Mandatory (Birth Location) -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Neighborhood / Village' | translate}}</p>
                <input type="text" name="birth_neighborhood" formControlName="birth_neighborhood" maxlength="40"
                  placeholder="{{'Enter Neighborhood / Village' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.birth_neighborhood.errors" class="invalid-feedback">
                <div *ngIf="g.birth_neighborhood.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.birth_neighborhood.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <div class="sub-section-with-line mb-3 birthdetails-section">
              <div class="mt-3">
                <h6 class="">{{'Location and contact details' | translate}}</h6>
              </div>
              <div class="line"></div>
            </div>

            <!-- Region - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Region' | translate}}<span class="mandatory">*</span></p>
                <input type="text" name="region" formControlName="region" maxlength="40"
                  placeholder="{{'Enter Region' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.region.errors" class="invalid-feedback">
                <div *ngIf="g.region.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.region.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- District - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'District2' | translate}}</p>
                <input type="text" name="district" formControlName="district" maxlength="40"
                  placeholder="{{'Enter District' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.district.errors" class="invalid-feedback">
                <div *ngIf="g.district.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.district.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- City - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'City2' | translate}}<span class="mandatory">*</span></p>
                <input type="text" name="city" formControlName="city" maxlength="40"
                  placeholder="{{'Enter City' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.city.errors" class="invalid-feedback">
                <div *ngIf="g.city.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.city.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Neighborhood - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Neighborhood / Village' | translate}}<span class="mandatory">*</span></p>
                <input type="text" name="neighborhood" formControlName="neighborhood" maxlength="40"
                  placeholder="{{'Enter Neighborhood / Village' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.neighborhood.errors" class="invalid-feedback">
                <div *ngIf="g.neighborhood.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.neighborhood.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Email Address - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Email Address' | translate}}<span class="mandatory">*</span></p>
                <input type="email" name="email" formControlName="email" maxlength="100"
                  placeholder="{{'Enter Email Address' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.email.errors" class="invalid-feedback">
                <div *ngIf="g.email.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.email.errors?.email || g.email.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Post Box - Optional -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Post Box' | translate}}</p>
                <input type="text" name="post_box" formControlName="post_box" maxlength="40"
                  placeholder="{{'Enter Post Box' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.post_box.errors" class="invalid-feedback">
                <div *ngIf="g.post_box.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Phone Number - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Phone Number' | translate}}<span class="mandatory">*</span></p>
                <input type="tel" name="mobile_no" formControlName="mobile" minlength="8" maxlength="8"
                  placeholder="{{'Enter Phone Number' | translate}}">
                <p class="note-small-text">Note : {{'Mobile should start with valid numbers like 77, 76, 74, 66, 65, 62, 60, 61'|translate}}</p>
              </div>
              <div *ngIf="isSubmit && g.mobile.errors" class="invalid-feedback">
                <div *ngIf="g.mobile.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.mobile.errors?.pattern">{{'This field should be valid'|translate}}</div>
                <div *ngIf="g.mobile.errors?.minlength">{{'This field should be valid'|translate}}</div>
                <div *ngIf="g.mobile.errors?.maxlength">{{'This field should be valid'|translate}}</div>
              </div>
            </div>
            <div class="sub-section-with-line mb-3 birthdetails-section">
              <div class="mt-3">
                <h6 class="">{{'Marital status' | translate}}</h6>
              </div>
              <div class="line"></div>
            </div>

            <!-- Marital Status - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Marital Status' | translate}}<span class="mandatory">*</span></p>
                <select type="text" [(ngModel)]="selectedMaritalStatus"
                  (change)="onMaritalStatusChange(g.marital_status.value)" name="marital_status"
                  class="bootstrap-select" formControlName="marital_status">
                  <option [value]="null" [selected]="!g.marital_status.value" disabled>{{'Please Select one' | translate}}</option>
                  <!-- <option *ngFor="let status of maritalStatusList" [value]="status.id">{{status.name | translate}}</option> -->
                  <option value="1">{{ 'Married (tradition)' | translate }}</option>
                  <option value="2">{{ 'Single' | translate }}</option>
                  <option value="3">{{ 'Widow' | translate }}</option>
                  <option value="4">{{ 'Divorced' | translate }}</option>
                  <option value="5">{{ 'Married (civil status)' | translate }}</option>
                </select>
              </div>
              <div *ngIf="isSubmit && g.marital_status.errors" class="invalid-feedback">
                <div *ngIf="g.marital_status.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>
            <div class="input-div" *ngIf="selectedMaritalStatus === '1'">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Married (Civil status)' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="marital_status_other" class="bootstrap-select"
                  formControlName="marital_status_other">
                  <option [value]="null" selected disabled>{{'Please Select one' | translate}}</option>

                  <option value="1">{{ 'Monogamy' | translate }}</option>
                  <option value="2">{{ 'Polygamy' | translate }}</option>

                </select>
              </div>
              <div *ngIf="isSubmit && g.marital_status_other.errors" class="invalid-feedback">
                <div *ngIf="g.marital_status_other.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>

            <!-- Marriage Date - Optional -->
            <div class="input-div" [owlDateTimeTrigger]="dtMarriage">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Marriage Date' | translate}}</p>
                <div class="date-field">
                  <input class="" [max]="todayDate" [owlDateTime]="dtMarriage" readonly name="marriage_date"
                    formControlName="marriage_date" placeholder="{{'Enter Marriage Date' | translate}}">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dtMarriage></owl-date-time>
              </div>
            </div>

            <!-- <div class="sub-section-with-line mb-3 birthdetails-section">
              <div class="mt-3">
                <h6 class="">{{'Affiliated with the Public Sector Fund' | translate}}</h6>
              </div>
              <div class="line"></div>
            </div> -->
            <!-- <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Administrative Status' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="administrative_status_public" class="bootstrap-select"
                  formControlName="administrative_status_public">
                  <option [value]="null" [selected]="!g.administrative_status_public.value" disabled>{{'Please Select one' | translate}}</option>
                  <option *ngFor="let status of administrativeStatusList" [value]="status.id">{{status.name | translate}}</option>
                </select>
              </div>
              <div *ngIf="isSubmit && g.administrative_status_public.errors" class="invalid-feedback">
                <div *ngIf="g.administrative_status_public.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Administration Code' | translate}}</p>
                <input type="text" name="administration_code" formControlName="administration_code" maxlength="40"
                  placeholder="{{'Enter Administration Code' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.administration_code.errors" class="invalid-feedback">
                <div *ngIf="g.administration_code.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div> -->
            <!-- <div class="input-div" [owlDateTimeTrigger]="dt46">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Hiring Date' | translate}}<span class="mandatory">*</span></p>
                <div class="date-field">
                  <input class="" [owlDateTime]="dt46" [min]="minJoinDate" [max]="todayDate" readonly name="joindate"
                    formControlName="joindate" placeholder="{{'Enter Hiring Date' | translate}}">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dt46></owl-date-time>
              </div>
              <div *ngIf="isSubmit && g.joindate.errors" class="invalid-feedback">
                <div *ngIf="g.joindate.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div> -->
            <!-- <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Category' | translate}}</p>
                <select type="text" name="category_public" class="bootstrap-select" formControlName="category_public">
                  <option [value]="null" [selected]="!g.category_public.value" disabled>{{'Please Select one' |
                    translate}}</option>
                  <option *ngFor="let category of categoryList.public" [value]="category.id">{{category.name |
                    translate}}</option>
                </select>
              </div>
            </div> -->
            <!-- <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Employee ID / Registration Number' | translate}}</p>
                <input type="text" name="employee_id" formControlName="employee_id" maxlength="40"
                  placeholder="{{'Enter Employee ID / Registration Number' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.employee_id.errors" class="invalid-feedback">
                <div *ngIf="g.employee_id.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div> -->
            <!-- <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Index' | translate}}</p>
                <input type="text" name="index" formControlName="index" maxlength="40"
                  placeholder="{{'Enter Index' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.index.errors" class="invalid-feedback">
                <div *ngIf="g.index.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Grade' | translate}}</p>
                <input type="text" name="grade" formControlName="grade" maxlength="40"
                  placeholder="{{'Enter Grade' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.grade.errors" class="invalid-feedback">
                <div *ngIf="g.grade.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div> -->

            <!-- Affiliation Type - Mandatory (Keep for validation, but not in user's list) -->
            <!-- <div class="input-div" style="display: none;">
                          <div class="input-box-white">
                              <p class="labeltxt ">{{'Affiliation Type' | translate}}<span class="mandatory">*</span></p>
                              <select type="text" name="affiliation_type" class="bootstrap-select" formControlName="affiliation_type">
                                  <option [value]="null" [selected]="!g.affiliation_type.value" disabled>{{'Please Select one' | translate}}</option>
                                  <option *ngFor="let affiliation of affiliationTypeList" [value]="affiliation.id">{{affiliation.name | translate}}</option>
                              </select>
                          </div>
                          <div *ngIf="isSubmit && g.affiliation_type.errors" class="invalid-feedback">
                              <div *ngIf="g.affiliation_type.errors?.required">{{'This field is mandatory'|translate}}</div>
                          </div>
                      </div> -->

            <!-- Affiliated with the Private Sector Fund Section -->
            <div class="sub-section-with-line mb-3 birthdetails-section">
              <div class="mt-3">
                <h6 class="">{{'Affiliated with the Private Sector Fund' | translate}}</h6>
              </div>
              <div class="line"></div>
            </div>

            <!-- Administrative Status - Mandatory (Private Sector) -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Administrative Status' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="administrative_status_private" class="bootstrap-select"
                  formControlName="administrative_status_private">
                  <option [value]="null" [selected]="!g.administrative_status_private.value" disabled>{{'Please Select one' | translate}}</option>
                  <option *ngFor="let status of administrativeStatusList" [value]="status.id">{{status.name | translate}}</option>
                </select>
              </div>
              <div *ngIf="isSubmit && g.administrative_status_private.errors" class="invalid-feedback">
                <div *ngIf="g.administrative_status_private.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>

            <!-- Employment / Activity Start Date - Optional (Private Sector) -->
            <div class="input-div" [owlDateTimeTrigger]="dtEmploymentStart">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Start date of activity / Employment' | translate}}</p>
                <div class="date-field">
                  <input class="" [max]="todayDate" [owlDateTime]="dtEmploymentStart" readonly
                    name="employment_start_date" formControlName="employment_start_date"
                    placeholder="{{'Select Start date of activity / Employment' | translate}}">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dtEmploymentStart></owl-date-time>
              </div>
            </div>

            <!-- Nature of Activity - Optional (Private Sector) -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Nature of Activity' | translate}}</p>
                <input type="text" name="nature_of_activity" formControlName="nature_of_activity" maxlength="100"
                  placeholder="{{'Enter Nature of Activity' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.nature_of_activity.errors" class="invalid-feedback">
                <div *ngIf="g.nature_of_activity.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Employer or Paying Organization ID - Optional (Private Sector) -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Employer or Paying Organization ID' | translate}}</p>
                <input type="text" name="employer_organization_id" formControlName="employer_organization_id"
                  maxlength="40" placeholder="{{'Enter Employer or Paying Organization ID' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.employer_organization_id.errors" class="invalid-feedback">
                <div *ngIf="g.employer_organization_id.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Employee ID with Employer / Organization - Optional (Private Sector) -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Employee\'s ID with the employer or paying organization' | translate}}</p>
                <input type="text" name="employee_id_employer" formControlName="employee_id_employer" maxlength="40"
                  placeholder="{{'Enter Employee\'s ID with the employer or paying organization' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.employee_id_employer.errors" class="invalid-feedback">
                <div *ngIf="g.employee_id_employer.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Category - Optional (Private Sector - Select Dropdown) -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Category' | translate}}</p>
                <select type="text" name="category_private" class="bootstrap-select" formControlName="category_private">
                  <option [value]="null" [selected]="!g.category_private.value" disabled>{{'Please Select one' |
                    translate}}</option>
                  <option *ngFor="let category of categoryList.private" [value]="category.id">{{category.name |
                    translate}}</option>
                </select>
              </div>
            </div>

            <!-- Documents to be uploaded Section -->
            <div class="sub-section-with-line mb-3 birthdetails-section">
              <div class="mt-3">
                <h6 class="">{{'Documents to be uploaded' | translate}}</h6>
              </div>
              <div class="line"></div>
            </div>

            <!-- ID Proof - Optional -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'ID Proof' | translate}} <span *ngIf="id_proof_url" class="ml-1"><i
                      class="fa fa-check-circle"></i></span></p>
                <label for="id_proof" class="file-upload-card labeltxt">
                  <div class="custom-container UploadIcon">
                    <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                    <i class="fa fa-upload " aria-hidden="true"></i>
                  </div>
                </label>
                <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
                <input class="" id="id_proof" type="file" formControlName="imageFile" hidden
                  (change)="upload($event, 'idProof')" data-target="id_proof" accept=".pdf,.jpg,.jpeg,.png">
                <a *ngIf="id_proof_url" id="id_proof" href="{{id_proof_url}}" target="_blank"
                  class="viewFile text-center">{{'Click to view File'|translate}}</a>
              </div>
              <div *ngIf="isSubmit && g.id_proof.errors" class="invalid-feedback">
                <div *ngIf="g.id_proof.errors.size">{{'File Size should not be greater than 10 MB.'|translate}}</div>
              </div>
            </div>

            <!-- Birth certificate of employee - Optional -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Birth certificate of employee' | translate}} <span
                    *ngIf="employee_birth_certificate_cnamgs_url" class="ml-1"><i class="fa fa-check-circle"></i></span>
                </p>
                <label for="employee_birth_certificate_cnamgs" class="file-upload-card labeltxt">
                  <div class="custom-container UploadIcon">
                    <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                    <i class="fa fa-upload " aria-hidden="true"></i>
                  </div>
                </label>
                <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
                <input class="" id="employee_birth_certificate_cnamgs" type="file" formControlName="imageFile" hidden
                  (change)="upload($event, 'employeeBirthCertificateCnamgs')"
                  data-target="employee_birth_certificate_cnamgs" accept=".pdf,.jpg,.jpeg,.png">
                <a *ngIf="employee_birth_certificate_cnamgs_url" id="employee_birth_certificate_cnamgs" href="{{employee_birth_certificate_cnamgs_url}}" target="_blank" class="viewFile text-center">{{'Click to view File'|translate}}</a>
              </div>
              <div *ngIf="isSubmit && g.employee_birth_certificate_cnamgs.errors" class="invalid-feedback">
                <div *ngIf="g.employee_birth_certificate_cnamgs.errors.size">{{'File Size should not be greater than 10 MB.'|translate}}</div>
              </div>
            </div>

            <!-- Marriage Certificate - Optional -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Marriage Certificate' | translate}} <span
                    *ngIf="marriage_certificate_cnamgs_url" class="ml-1"><i class="fa fa-check-circle"></i></span></p>
                <label for="marriage_certificate_cnamgs" class="file-upload-card labeltxt">
                  <div class="custom-container UploadIcon">
                    <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                    <i class="fa fa-upload " aria-hidden="true"></i>
                  </div>
                </label>
                <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
                <input class="" id="marriage_certificate_cnamgs" type="file" formControlName="imageFile" hidden
                  (change)="upload($event, 'marriageCertificateCnamgs')" data-target="marriage_certificate_cnamgs"
                  accept=".pdf,.jpg,.jpeg,.png">
                <a *ngIf="marriage_certificate_cnamgs_url" id="marriage_certificate_cnamgs"
                  href="{{marriage_certificate_cnamgs_url}}" target="_blank" class="viewFile text-center">{{'Click to view File'|translate}}</a>
              </div>
              <div *ngIf="isSubmit && g.marriage_certificate_cnamgs.errors" class="invalid-feedback">
                <div *ngIf="g.marriage_certificate_cnamgs.errors.size">{{'File Size should not be greater than 10 MB.'|translate}}</div>
              </div>
            </div>

            <!-- Birth certificate of spouse - Optional -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Birth certificate of spouse' | translate}} <span
                    *ngIf="spouse_birth_certificate_cnamgs_url" class="ml-1"><i class="fa fa-check-circle"></i></span>
                </p>
                <label for="spouse_birth_certificate_cnamgs" class="file-upload-card labeltxt">
                  <div class="custom-container UploadIcon">
                    <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                    <i class="fa fa-upload " aria-hidden="true"></i>
                  </div>
                </label>
                <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
                <input class="" id="spouse_birth_certificate_cnamgs" type="file" formControlName="imageFile" hidden
                  (change)="upload($event, 'spouseBirthCertificateCnamgs')"
                  data-target="spouse_birth_certificate_cnamgs" accept=".pdf,.jpg,.jpeg,.png">
                <a *ngIf="spouse_birth_certificate_cnamgs_url" id="spouse_birth_certificate_cnamgs"
                  href="{{spouse_birth_certificate_cnamgs_url}}" target="_blank" class="viewFile text-center">{{'Click to view File'|translate}}</a>
              </div>
              <div *ngIf="isSubmit && g.spouse_birth_certificate_cnamgs.errors" class="invalid-feedback">
                <div *ngIf="g.spouse_birth_certificate_cnamgs.errors.size">{{'File Size should not be greater than 10 MB.'|translate}}</div>
              </div>
            </div>

            <!-- Payslip (last three months) - Optional -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Payslip (last three months)' | translate}} <span *ngIf="payslips_url"
                    class="ml-1"><i class="fa fa-check-circle"></i></span></p>
                <label for="payslips" class="file-upload-card labeltxt">
                  <div class="custom-container UploadIcon">
                    <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                    <i class="fa fa-upload " aria-hidden="true"></i>
                  </div>
                </label>
                <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
                <input class="" id="payslips" type="file" formControlName="imageFile" hidden
                  (change)="upload($event, 'payslips')" data-target="payslips" accept=".pdf,.jpg,.jpeg,.png">
                <a *ngIf="payslips_url" id="payslips" href="{{payslips_url}}" target="_blank"
                  class="viewFile text-center">{{'Click to view File'|translate}}</a>
              </div>
              <div *ngIf="isSubmit && g.payslips.errors" class="invalid-feedback">
                <div *ngIf="g.payslips.errors.size">{{'File Size should not be greater than 10 MB.'|translate}}</div>
              </div>
            </div>
          </div>

          <div class="nif-btn-submit-div text-center ">
            <button type="button" class="btn btn-medium"
              (click)="onSubmitEmployeeStage2()">{{'Submit'|translate}}</button>
          </div>
        </div>
      </div>

      <!-- CNSS "No" Form Card - Hide in hiring flow, only show in CNSS registration flow -->
      <!-- CNSS Registration Form - Only show in CNSS registration flow -->
      <div class="verify-inner-box-div text-input-left cnss-cnamgs-registeration"
        *ngIf="isCnssEmployeeRegistrationFlow && showCnssSection">
        <div class="employer-manager-details-section">
          <div class="display-flex-head-mobile mb-5">
            <h2 class="text-center mb-0">{{'CNSS Registration' | translate}}</h2>
          </div>

          <!-- <div class="sub-section-with-line mb-3">
                    <div class="container mt-5">
                      <h6 class="">{{'CNSS Registration details' | translate}}<span class="mandatory" >*</span></h6>
                    </div>
                    <div class="line"></div>
                </div> -->

          <div class="form-grid-group">
            <!-- First name and Last name - shown only for no-ID CNSS flow -->
            <div class="input-div" *ngIf="employeeHasNoId">
              <div class="input-box-white">
                <p class="labeltxt">{{'First name' | translate}}<span class="mandatory">*</span></p>
                <input type="text" name="first_name" formControlName="first_name" maxlength="40" placeholder="{{'Enter First name' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.first_name.errors" class="invalid-feedback">
                <div *ngIf="g.first_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.first_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>
            <div class="input-div" *ngIf="employeeHasNoId">
              <div class="input-box-white">
                <p class="labeltxt">{{'Last name' | translate}}<span class="mandatory">*</span></p>
                <input type="text" name="last_name" formControlName="last_name" maxlength="40" placeholder="{{'Enter Last name' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.last_name.errors" class="invalid-feedback">
                <div *ngIf="g.last_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.last_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>
            <!-- Gender - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Gender' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="gender" class="bootstrap-select" formControlName="gender"
                  [(ngModel)]="employeeGender" (change)="genderChange($event.target.value)">
                  <option [ngValue]="null" disabled>{{'Please Select Gender' | translate}}
                  </option>
                  <option [ngValue]="'1'"> {{'Male' | translate}}</option>
                  <option [ngValue]="'2'"> {{'Female' | translate}} </option>
                </select>
              </div>
              <div *ngIf="isSubmit && g.gender.errors" class="invalid-feedback">
                <div *ngIf="g.gender.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.gender.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Maiden Name - Optional, shown only if employee is female -->
            <div class="input-div" *ngIf="employeeGender == 2">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Maiden name' | translate}}</p>
                <input type="text" name="maiden_name" formControlName="maiden_name" maxlength="40"
                  placeholder="{{'Enter Maiden Name' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.maiden_name.errors" class="invalid-feedback">
                <div *ngIf="g.maiden_name.errors?.pattern">{{'This field should be valid'|translate}}
                </div>
              </div>
            </div>

            <!-- Date of Birth - Mandatory -->
            <div class="input-div" [owlDateTimeTrigger]="dt43">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Date of Birth' | translate}}<span class="mandatory">*</span></p>
                <div class="date-field">
                  <input class="" [max]="maxDateOfBirth" [min]="minDobDate" [owlDateTime]="dt43" name="dob"
                    formControlName="dob" placeholder="{{'Enter Date of Birth' | translate}}">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dt43></owl-date-time>
              </div>
              <div *ngIf="isSubmit && g.dob.errors" class="invalid-feedback">
                <div *ngIf="g.dob.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.dob.errors?.minAge">{{ 'Minimum age requirement is 16 years' | translate }}</div>
              </div>
            </div>

            <!-- Nationality - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Nationality' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="nationality" formControlName="nationality" maxlength="40">
                  <option [ngValue]="null" disabled>{{'Please Select Nationality' |
                    translate}}</option>
                  <option *ngFor="let country of countryList" [ngValue]="country.id">{{country.name | translate}}</option>
                </select>
              </div>
              <div *ngIf="isSubmit && g.nationality.errors" class="invalid-feedback">
                <div *ngIf="g.nationality.errors?.required">{{'This field is mandatory'|translate}}
                </div>
                <div *ngIf="g.nationality.errors?.pattern">{{'This field should be valid'|translate}}
                </div>
              </div>
            </div>

            <!-- Place of Birth -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Place of Birth' | translate}}</p>
                <input type="text" name="birthplace" formControlName="birthplace" maxlength="40"
                  placeholder="{{'Enter Place of Birth' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.birthplace.errors" class="invalid-feedback">
                <div *ngIf="g.birthplace.errors?.pattern">{{'This field should be valid'|translate}}
                </div>
              </div>
            </div>

            <!-- Birth Certificate Number -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Birth Certificate Number' | translate}}</p>
                <input type="text" name="birth_certificate_number" formControlName="birth_certificate_number"
                  maxlength="40" placeholder="{{'Enter Birth Certificate Number' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.birth_certificate_number.errors" class="invalid-feedback">
                <div *ngIf="g.birth_certificate_number.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Birth Certificate Issue Date - Optional -->
            <div class="input-div" [owlDateTimeTrigger]="dtBirthCert">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Birth Certificate Issue Date' | translate}}</p>
                <div class="date-field">
                  <input class="" [max]="todayDate" [owlDateTime]="dtBirthCert" readonly
                    name="birth_certificate_issue_date" formControlName="birth_certificate_issue_date"
                    placeholder="{{'Enter Birth Certificate Issue Date' | translate}}">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dtBirthCert></owl-date-time>
              </div>
            </div>
            <!-- Marital Status - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Marital Status' | translate}}<span class="mandatory">*</span></p>
                <select type="text" [(ngModel)]="selectedMaritalStatus"
                  (change)="onMaritalStatusChange(g.marital_status.value)" name="marital_status"
                  class="bootstrap-select" formControlName="marital_status">
                  <option [ngValue]="null" disabled>{{'Please Select one' |
                    translate}}</option>
                  <!-- <option *ngFor="let status of maritalStatusList" [value]="status.id">{{status.name | translate}}</option> -->

                  <option [ngValue]="'1'">{{ 'Married (civil status)' | translate }}</option>
                  <option [ngValue]="'2'">{{ 'Single' | translate }}</option>
                  <option [ngValue]="'3'">{{ 'Widow' | translate }}</option>
                  <option [ngValue]="'4'">{{ 'Divorced' | translate }}</option>
                  <option [ngValue]="'5'">{{ 'Married (tradition)' | translate }}</option>

                </select>
              </div>
              <div *ngIf="isSubmit && g.marital_status.errors" class="invalid-feedback">
                <div *ngIf="g.marital_status.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>
            <div class="input-div" *ngIf="selectedMaritalStatus === '1'">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Married (Civil status)' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="marital_status_other" class="bootstrap-select"
                  formControlName="marital_status_other">
                  <option [ngValue]="null" disabled>{{'Please Select one' | translate}}</option>


                  <option [ngValue]="'1'">{{ 'Monogamy' | translate }}</option>
                  <option [ngValue]="'2'">{{ 'Polygamy' | translate }}</option>

                </select>
              </div>
              <div *ngIf="isSubmit && g.marital_status_other.errors" class="invalid-feedback">
                <div *ngIf="g.marital_status_other.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>

            <!-- ID Proof Type - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'ID Proof Type' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="Identity Document" class="bootstrap-select" formControlName="id_type">
                  <option [ngValue]="null" disabled>{{'Please Select one' | translate}}
                  </option>
                  <option *ngFor="let idType of idtypelist" [ngValue]="idType.id">{{idType.name | translate}}</option>
                </select>
              </div>
              <div *ngIf="isSubmit && g.id_type.errors" class="invalid-feedback">
                <div *ngIf="g.id_type.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.id_type.errors?.pattern">{{'This field should be valid'|translate}}
                </div>
              </div>
            </div>

            <!-- ID Proof Number -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'ID Proof Number' | translate}}</p>
                <input type="text" name="id_num" formControlName="id_number" maxlength="40"
                  placeholder="{{'Enter ID Proof Number' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.id_number.errors" class="invalid-feedback">
                <div *ngIf="g.id_number.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- ID Proof Expiry Date - Optional -->
            <div class="input-div" [owlDateTimeTrigger]="dtIdExpiry">
              <div class="input-box-white">
                <p class="labeltxt ">{{'ID Proof Expiry Date' | translate}}</p>
                <div class="date-field">
                  <input class="" [min]="todayDate" [owlDateTime]="dtIdExpiry" readonly name="id_proof_expiry_date"
                    formControlName="id_proof_expiry_date" placeholder="{{'Enter ID Proof Expiry Date' | translate}}">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dtIdExpiry></owl-date-time>
              </div>
            </div>

            <!-- Phone Number - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Phone Number2' | translate}}<span class="mandatory">*</span></p>
                <input type="tel" name="mobile_no" formControlName="mobile" minlength="8" maxlength="8"
                  placeholder="{{'Enter Phone Number' | translate}}">
                <p class="note-small-text">Note : {{'Mobile should start with valid numbers like 77, 76, 74, 66, 65, 62, 60, 61'|translate}}</p>
              </div>
              <div *ngIf="isSubmit && g.mobile.errors" class="invalid-feedback">
                <div *ngIf="g.mobile.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.mobile.hasError('pattern')">{{'This field should be valid'|translate}}</div>
                <div *ngIf="g.mobile.hasError('minlength') && !g.mobile.hasError('pattern')">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Email Address - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Email Address' | translate}}<span class="mandatory">*</span></p>
                <input type="email" name="email" formControlName="email" maxlength="100"
                  placeholder="{{'Enter Email Address' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.email.errors" class="invalid-feedback">
                <div *ngIf="g.email.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.email.errors?.email">{{'This field should be valid'|translate}}</div>
                <div *ngIf="g.email.errors?.pattern">{{'This field should be valid'|translate}}
                </div>
              </div>
            </div>



            <!-- Professional Category - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Professional Category' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="professional_category" class="bootstrap-select"
                  formControlName="professional_category" [(ngModel)]="selectedProfessionalCategory"
                  (change)="onProfessionalCategoryChange(g.professional_category.value)">
                  <option [ngValue]="null" disabled>{{'Please Select one' | translate}}</option>
                  <option *ngFor="let category of professionalCategoryList" [ngValue]="category.id">{{category.name | translate}}</option>
                </select>
              </div>
              <div *ngIf="isSubmit && g.professional_category.errors" class="invalid-feedback">
                <div *ngIf="g.professional_category.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>

            <!-- Professional Category Other - Show if Other is selected -->
            <div class="input-div" *ngIf="selectedProfessionalCategory === '7'">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Please specify professional category' | translate}}<span
                    class="mandatory">*</span></p>
                <input type="text" name="professional_category_other" formControlName="professional_category_other"
                  maxlength="100" placeholder="{{'Please specify' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.professional_category_other.errors" class="invalid-feedback">
                <div *ngIf="g.professional_category_other.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.professional_category_other.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Employee Type - Mandatory -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Employee Type' | translate}}<span class="mandatory">*</span></p>
                <select type="text" name="employee_type" class="bootstrap-select" formControlName="employee_type"
                  [(ngModel)]="selectedEmployeeType" (change)="onEmployeeTypeChange(g.employee_type.value)">
                  <option [ngValue]="null" disabled>{{'Please Select one' | translate}}</option>
                  <option *ngFor="let empType of employeeTypeList" [ngValue]="empType.id">{{empType.name | translate}}
                  </option>
                </select>
              </div>
              <div *ngIf="isSubmit && g.employee_type.errors" class="invalid-feedback">
                <div *ngIf="g.employee_type.errors?.required">{{'This field is mandatory'|translate}}
                </div>
              </div>
            </div>

            <!-- Employee Type Other - Show if Other is selected -->
            <div class="input-div" *ngIf="selectedEmployeeType === '7'">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Please specify Employee Type' | translate}}<span class="mandatory">*</span></p>
                <input type="text" name="employee_type_other" formControlName="employee_type_other" maxlength="100"
                  placeholder="{{'Please specify' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.employee_type_other.errors" class="invalid-feedback">
                <div *ngIf="g.employee_type_other.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>

            <!-- Occupation / Position Held - Optional -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Occupation / Position Held' | translate}}</p>
                <input type="text" name="position" formControlName="position" maxlength="40"
                  placeholder="{{'Enter Occupation / Position Held' | translate}}">
              </div>
              <div *ngIf="isSubmit && g.position.errors" class="invalid-feedback">
                <div *ngIf="g.position.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Hiring Date - Mandatory -->
            <div class="input-div" [owlDateTimeTrigger]="dt46">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Hiring Date' | translate}}<span class="mandatory">*</span></p>
                <div class="date-field">
                  <input class="" [owlDateTime]="dt46" [min]="minJoinDate" [max]="todayDate" readonly name="joindate"
                    formControlName="joindate" placeholder="{{'Enter Hiring Date' | translate}}">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dt46></owl-date-time>
              </div>
              <div *ngIf="isSubmit && g.joindate.errors" class="invalid-feedback">
                <div *ngIf="g.joindate.errors?.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.joindate.errors?.pattern">{{'This field should be valid'|translate}}</div>
              </div>
            </div>

            <!-- Hiring Certificate Date - Optional -->
            <div class="input-div" [owlDateTimeTrigger]="dtHiringCert">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Hiring Certificate Date' | translate}}</p>
                <div class="date-field">
                  <input class="" [max]="todayDate" [owlDateTime]="dtHiringCert" readonly name="hiring_certificate_date"
                    formControlName="hiring_certificate_date"
                    placeholder="{{'Enter Hiring Certificate Date' | translate}}">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dtHiringCert></owl-date-time>
              </div>
            </div>

            <!-- ID Proof File Upload -->
            <div class="input-div">
              <div class="input-box-white employee-form-img">
                <p class="labeltxt ">{{'ID Proof' | translate}}<span class="mandatory">*</span> <span
                    *ngIf="id_Front_Photo" class="ml-1"><i class="fa fa-check-circle"></i></span></p>
                <label for="id_Front_Photo" class="file-upload-card labeltxt">
                  <div class="custom-container UploadIcon">
                    <p class="text-center">{{'Upload ID Proof or drop a file' | translate}}</p>
                    <i class="fa fa-upload " aria-hidden="true"></i>
                  </div>
                </label>
                <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
                <input class="" id="id_Front_Photo" type="file" formControlName="imageFile" hidden
                  (change)="upload($event, 'idFrontPhoto')" data-target="id_Front_Photo">
                <a *ngIf="id_Front_Photo" id="id_Front_Photo" href="{{id_Front_Photo}}" target="_blank"
                  class="viewFile text-center">{{'Click to view File'|translate}}</a>
              </div>
              <div *ngIf="isSubmit && g.id_Front_Photo.errors" class="invalid-feedback">
                <div *ngIf="g.id_Front_Photo.errors.required">{{'This field is mandatory'|translate}}</div>
                <div *ngIf="g.id_Front_Photo.errors.size">{{'File Size should not be grater than 10 MB.'|translate}}
                </div>
              </div>
            </div>

            <!-- Birth Certificate File Upload -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Birth Certificate' | translate}} <span *ngIf="birth_certificate_file_url"
                    class="ml-1"><i class="fa fa-check-circle"></i></span></p>
                <label for="birth_certificate_file" class="file-upload-card labeltxt">
                  <div class="custom-container UploadIcon">
                    <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                    <i class="fa fa-upload " aria-hidden="true"></i>
                  </div>
                </label>
                <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
                <input class="" id="birth_certificate_file" type="file" formControlName="imageFile" hidden
                  (change)="upload($event, 'birthCertificate')" data-target="birth_certificate_file">
                <a *ngIf="birth_certificate_file_url" id="birth_certificate_file" href="{{birth_certificate_file_url}}"
                  target="_blank" class="viewFile text-center">{{'Click to view File'|translate}}</a>
              </div>
              <div *ngIf="isSubmit && g.birth_certificate_file.errors" class="invalid-feedback">
                <div *ngIf="g.birth_certificate_file.errors.size">{{'File Size should not be grater than 10 MB.'|translate}}</div>
              </div>
            </div>

            <!-- Marriage Certificate File Upload -->
            <div class="input-div">
              <div class="input-box-white">
                <p class="labeltxt ">{{'Marriage Certificate' | translate}} <span *ngIf="marriage_certificate_file_url"
                    class="ml-1"><i class="fa fa-check-circle"></i></span></p>
                <label for="marriage_certificate_file" class="file-upload-card labeltxt">
                  <div class="custom-container UploadIcon">
                    <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                    <i class="fa fa-upload " aria-hidden="true"></i>
                  </div>
                </label>
                <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
                <input class="" id="marriage_certificate_file" type="file" formControlName="imageFile" hidden
                  (change)="upload($event, 'marriageCertificate')" data-target="marriage_certificate_file">
                <a *ngIf="marriage_certificate_file_url" id="marriage_certificate_file"
                  href="{{marriage_certificate_file_url}}" target="_blank" class="viewFile text-center">{{'Click to view File'|translate}}</a>
              </div>
              <div *ngIf="isSubmit && g.marriage_certificate_file.errors" class="invalid-feedback">
                <div *ngIf="g.marriage_certificate_file.errors.size">{{'File Size should not be grater than 10 MB.'|translate}}</div>
              </div>
            </div>
          </div>

          <div class="nif-btn-submit-div text-center ">
            <button type="button" class="btn btn-medium"
              (click)="onSubmitEmployeeStage2()">{{'Submit'|translate}}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Employee Details Form Card - Show only when CNSS is not "no" and CNAMGS is "yes" -->



  </form>
</div>
<app-footer></app-footer>
<app-add-bank></app-add-bank>
<section class="modal-section2 bulk-upload-modal">
  <div class="modal fade" id="bulkUpload" data-backdrop="true" data-keyboard="false" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate"
          (click)="closeModal('1')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="parent">
            <div class="image-container">
              <img src="assets/images/Link-sucsess.png" style="width: 50%;margin: 0 auto;display: block;">
            </div>
            <div class="text-container text-center">
              <h4 class="modal-header-txt">{{'Bulk Upload Employees' | translate}}</h4>
              <p class="para-light text-emp-p">{{'Please Download and Use the Below Excel Template to Bulk Upload Employees' |
                translate}}</p>
              <form [formGroup]="EmpolyeeBulkUploadForm">
                <div class="bulk-upload-container">
                  <button class="btn btn-medium" (click)="downloadExcel()">{{'Download' | translate}} </button>
                  <label class="btn btn-medium btn-green" (click)="openBulkUploadModal()">{{'Upload' | translate}}</label>
                  <input id="bulkUploadEmployee" type="file" formControlName="bulkUpload"
                    (change)="bulkUpload($event, 'bulkUpload')" data-target="bulkUploadEmployee" style="display: none;">
                  <a id="bulkUpload" href="{{imageUrl}}" target="_blank" class="viewFile text-center"></a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- <section class="modal-section2 bulk-upload-modal">
  <div class="modal fade" id="bulkUpload" data-backdrop="true" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="parent">
            <div class="image-container">
              <img src="assets/images/Link-sucsess.png" style="width: 50%;margin: 0 auto;display: block;">
            </div>
            <div class="text-container text-center">
              <h4 class="modal-header-txt">{{'Bulk Upload Employees' | translate}}</h4>
              <p class="para-light">{{'Please Download and Use the Below Excel Template to Bulk Upload Employees' |
                translate}}</p>
              <form [formGroup]="EmpolyeeBulkUploadForm">
                <div class="bulk-upload-container">
                  <button class="btn btn-medium" (click)="downloadExcel()">{{'Download' | translate}} </button>
                  <label class="btn btn-medium" for="bulkUploadEmployee">{{'Upload' | translate}}</label>
                  <input id="bulkUploadEmployee" type="file" formControlName="bulkUpload" hidden (change)="upload($event, 'bulkUpload')" data-target="bulkUploadEmployee">
                  <a id="bulkUpload" href="{{imageUrl}}" target="_blank" class="viewFile text-center"></a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->
<section class="modal-section2 bulk-upload-modal">
  <div class="modal fade" id="allEmployeeModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="parent-container">
            <h5 class="form-title text-center"
              *ngIf="!isFromNoCnssRegistration && !isFromNoCnamgsRegistration && !isFromCnamgsYesRegistration">{{'List of Employees to Add' | translate}}</h5>
            <h5 class="form-title text-center" *ngIf="isFromNoCnssRegistration">{{'Employee CNSS Registration Submitted' | translate}}</h5>
            <h5 class="form-title text-center" *ngIf="isFromNoCnamgsRegistration">{{'Employee CNAMGS Registration Submitted' | translate}}</h5>
            <h5 class="form-title text-center" *ngIf="isFromCnamgsYesRegistration">{{'Employee Hiring Details Submitted'
              | translate}}</h5>
            <!-- <p *ngIf="isFromNoCnssRegistration || isFromNoCnamgsRegistration || isFromCnamgsYesRegistration" class="text-center mt-2 mb-3">{{'Employee details submitted successfully. Please review and submit for verification.' | translate}}</p> -->

            <section class="quiz_section" id="quizeSection">
              <div class="container">
                <div class="row">
                  <!-- <h5 class="quiz-head">{{'Only Selected Employees will send for verification' | translate }}</h5> -->
                  <div class="col-sm-12" *ngFor="let employee of employeespendingList">
                    <div class="quiz_card_area">
                      <input class="quiz_checkbox styled-checkbox" type="checkbox" [id]="employee.id"
                        [value]="employee.id" checked="checked"
                        (change)="onChange(employee.id, $event.target.checked)" />
                      <label [for]="employee.id"></label>
                      <!-- <i (click)="showAddEmployee(employee.uuid, '2')" class="fa-regular fa-pen-to-square"></i> -->
                      <i (click)="deletePendingEmployee(employee.uuid)" class="fa-solid fa-trash"></i>
                      <div class="single_quiz_card">
                        <div class="quiz_card_content">
                          <div class="quiz_card_title">
                            <h3>{{ employee.name }}</h3>
                          </div>
                          <div class="quiz_card_icon">
                            <!-- Show all fields from CNSS No form when isFromNoCnssRegistration is true -->
                            <div *ngIf="isFromNoCnssRegistration" class="row">
                              <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                  <label>{{'First Name' | translate }} :</label>
                                  <h3>{{ (employee?.first_name | translate) || '--' }}</h3>
                                </div>

                                <div class="d-flex align-items-center">
                                  <label>{{'Occupation' | translate }} :</label>
                                  <h3>{{ (employee?.position | translate) || '--' }}</h3>
                                </div>

                                <!-- <div class="d-flex align-items-center">
                                  <label>{{'Place of Birth' | translate }} :</label>
                                  <h3>{{ (employee?.birthplace | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Birth Certificate Number' | translate }} :</label>
                                  <h3>{{ (employee?.birth_certificate_number | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Birth Certificate Issue Date' | translate }} :</label>
                                  <h3>{{ (employee?.birth_certificate_issue_date | translate) || '--' }}</h3>
                                </div>
                                 <div class="d-flex align-items-center">
                                  <label>{{'Marital Status' | translate }} :</label>
                                  <h3>{{ (employee?.marital_status | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'ID Proof Type' | translate }} :</label>
                                  <h3>{{ (employee?.id_type | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'ID Proof Number' | translate }} :</label>
                                  <h3>{{ (employee?.id_number | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'ID Proof Expiry Date' | translate }} :</label>
                                  <h3>{{ (employee?.id_proof_expiry_date | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Phone Number' | translate }} :</label>
                                  <h3>{{ (employee?.mobile | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Email Address' | translate }} :</label>
                                    <h3>{{ (employee?.email | translate) || '--' }}</h3>
                                </div> -->
                              </div>
                              <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                  <label>{{'Last Name' | translate }} :</label>
                                  <h3>{{ (employee?.last_name | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Join Date' | translate }} :</label>
                                  <h3>{{ (employee?.joindate | translate) || '--' }}</h3>
                                </div>
                                <!-- <div class="d-flex align-items-center">
                                  <label>{{'Professional Category' | translate }} :</label>
                                  <h3>{{ (employee?.professional_category | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Employee Type' | translate }} :</label>
                                  <h3>{{ (employee?.employee_type | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Occupation / Position Held' | translate }} :</label>
                                  <h3>{{ (employee?.position | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Hiring Date' | translate }} :</label>
                                  <h3>{{ (employee?.joindate | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Hiring Certificate Date' | translate }} :</label>
                                  <h3>{{ (employee?.hiring_certificate_date | translate) || '--' }}</h3>
                                </div> -->
                              </div>
                            </div>

                            <!-- Show CNAMGS No form fields when isFromNoCnamgsRegistration is true -->
                            <div *ngIf="isFromNoCnamgsRegistration" class="row">
                              <div class="col-md-6">
                                <!-- <div class="d-flex align-items-center">
                                  <label>{{'Photo' | translate }} :</label>
                                  <h3>{{ (employee?.image | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Gender' | translate }} :</label>
                                  <h3>{{ (employee?.gender | translate) || '--' }}</h3>
                                </div>
                                <div *ngIf="employee?.maiden_name" class="d-flex align-items-center">
                                  <label>{{'Maiden Name' | translate }} :</label>
                                  <h3>{{ (employee?.maiden_name | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Father Name' | translate }} :</label>
                                  <h3>{{ (employee?.father_name | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Mother Name' | translate }} :</label>
                                  <h3>{{ (employee?.mother_name | translate) || '--' }}</h3>
                                </div>
                                 <div class="d-flex align-items-center">
                                  <label>{{'ID Proof Type' | translate }} :</label>
                                  <h3>{{ (employee?.id_type | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Date of Birth' | translate }} :</label>
                                  <h3>{{ (employee?.dob | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Region' | translate }} :</label>
                                  <h3>{{ (employee?.region | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'City ' | translate }} :</label>
                                  <h3>{{ (employee?.city | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'District2' | translate }} :</label>
                                  <h3>{{ (employee?.district | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Neighborhood / Village' | translate }} :</label>
                                  <h3>{{ (employee?.neighborhood | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Email Address' | translate }} :</label>
                                  <h3>{{ (employee?.email | translate) || '--' }}</h3>
                                </div>
                                 <div class="d-flex align-items-center">
                                  <label>{{'Post Box' | translate }} :</label>
                                  <h3>{{ (employee?.post_box | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Phone Number' | translate }} :</label>
                                  <h3>{{ (employee?.mobile | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Marital Status' | translate }} :</label>
                                  <h3>{{ (employee?.marital_status | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Marriage Date' | translate }} :</label>
                                  <h3>{{ (employee?.marriage_date | translate) || '--' }}</h3>
                                </div> -->
                                <div class="d-flex align-items-center">
                                  <label>{{'First Name' | translate }} :</label>
                                  <h3>{{ (employee?.first_name | translate) || '--' }}</h3>
                                </div>

                                <div class="d-flex align-items-center">
                                  <label>{{'Occupation' | translate }} :</label>
                                  <h3>{{ (employee?.position | translate) || '--' }}</h3>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <!-- <div class="d-flex align-items-center">
                                  <label>{{'Administrative Status' | translate }} :</label>
                                    <h3>{{ (employee?.administrative_status | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Administration Code' | translate }} :</label>
                                    <h3>{{ (employee?.administration_code | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Hiring / Start Date' | translate }} :</label>
                                    <h3>{{ (employee?.joindate | translate) || '--' }}</h3>
                                </div>
                                 <div class="d-flex align-items-center">
                                  <label>{{'Affiliation Type' | translate }} :</label>
                                    <h3>{{ (employee?.affiliation_type | translate) || '--' }}</h3>
                                </div>
                                 <div class="d-flex align-items-center">
                                  <label>{{'Employee ID / Registration Number' | translate }} :</label>
                                    <h3>{{ (employee?.employee_id | translate) || '--' }}</h3>
                                </div>
                                 <div class="d-flex align-items-center">
                                  <label>{{'Index' | translate }} :</label>
                                    <h3>{{ (employee?.index | translate) || '--' }}</h3>
                                </div>
                                 <div class="d-flex align-items-center">
                                  <label>{{'Grade' | translate }} :</label>
                                    <h3>{{ (employee?.grade | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Employment / Activity Start Date' | translate }} :</label>
                                  <h3>{{ (employee?.employment_start_date | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Nature of Activity' | translate }} :</label>
                                  <h3>{{ (employee?.nature_of_activity | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Employer or Paying Organization ID' | translate }} :</label>
                                  <h3>{{ (employee?.employer_organization_id | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Employee ID with Employer / Organization' | translate }} :</label>
                                  <h3>{{ (employee?.employee_id_employer | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Category' | translate }} :</label>
                                  <h3>{{ (employee?.category | translate) || '--' }}</h3>
                                </div>
                              <div class="d-flex align-items-center">
                                  <label>{{'ID Proof' | translate }} :</label>
                                  <h3>{{ (employee?.id_proof | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Employee Birth Certificate' | translate }} :</label>
                                  <h3>{{ (employee?.employee_birth_certificate_cnamgs | translate) || '--'  }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Marriage Certificate' | translate }} :</label>
                                  <h3>{{ (employee?.marriage_certificate_cnamgs | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Spouse Birth Certificate' | translate }} :</label>
                                  <h3>{{ (employee?.spouse_birth_certificate_cnamgs | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Payslips (Last 3 Months)' | translate }} :</label>
                                  <h3>{{ (employee?.payslips | translate) || '--' }}</h3>
                                </div> -->
                                <div class="d-flex align-items-center">
                                  <label>{{'Last Name' | translate }} :</label>
                                  <h3>{{ (employee?.last_name | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Join Date' | translate }} :</label>
                                  <h3>{{ (employee?.joindate | translate) || '--' }}</h3>
                                </div>
                              </div>
                            </div>

                            <!-- Show CNAMGS Yes form fields when isFromCnamgsYesRegistration is true -->
                            <!-- Only show fields that exist in the Employee Details form (lines 507-627) -->
                            <div *ngIf="isFromCnamgsYesRegistration" class="row">
                              <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                  <label>{{'Hiring Date' | translate }} :</label>
                                  <h3>{{ (employee?.joindate | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Hiring Certificate Date' | translate }} :</label>
                                  <h3>{{ (employee?.hiring_certificate_date | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Type of Contract' | translate }} :</label>
                                  <h3>{{ (employee?.type_of_contract | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Contract End Date' | translate }} :</label>
                                  <h3>{{ (employee?.contract_end_date | translate) || '--' }}</h3>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                  <label>{{'Professional Rank' | translate }} :</label>
                                  <h3>{{ (employee?.professional_rank | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Employee Type' | translate }} :</label>
                                  <h3>{{ (employee?.employee_type | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Occupation / Position' | translate }} :</label>
                                  <h3>{{ (employee?.position | translate) || '--' }}</h3>
                                </div>
                              </div>
                            </div>

                            <!-- Show original fields when NOT from CNSS No registration and NOT from CNAMGS No registration and NOT from CNAMGS Yes registration -->
                            <div
                              *ngIf="!isFromNoCnssRegistration && !isFromNoCnamgsRegistration && !isFromCnamgsYesRegistration"
                              class="row">
                              <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                  <label>{{'Date of Birth' | translate }} :</label>
                                  <h3>{{ (employee?.dob_type | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Designation' | translate }} :</label>
                                  <h3>{{ (employee?.designation | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'CNAMGS ID' | translate }} :</label>
                                  <h3>{{ (employee?.cnamgs | translate) || '--' }}</h3>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="d-flex align-items-center">
                                  <label>{{'CNSS ID' | translate}} :</label>
                                  <h3>{{ (employee?.cnss | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Mobile' | translate}} :</label>
                                  <h3>{{ (employee?.mobile | translate) || '--' }}</h3>
                                </div>
                                <div class="d-flex align-items-center">
                                  <label>{{'Join Date' | translate}} :</label>
                                  <h3>{{ (employee?.join_date | translate) || '--' }}</h3>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex buttons">
                <!-- Normal Employee Details Flow -->
                <button (click)="submitEmployees()" id="submit_btn" class="btn btn-medium"
                  *ngIf="!isFromNoCnssRegistration && !isFromNoCnamgsRegistration && !isFromCnamgsYesRegistration">{{'Submit'
                  |
                  translate}}</button>
                <!-- <button id="submit_btn" class="btn btn-medium" *ngIf="!isFromNoCnssRegistration && !isFromNoCnamgsRegistration && !isFromCnamgsYesRegistration" (click)="registerNewEmployee()">{{'Add More employees' |
                  translate}}</button> -->

                <!-- CNAMGS Yes Registration Flow -->
                <button (click)="submitEmployees()" id="submit_btn" class="btn btn-medium"
                  *ngIf="isFromCnamgsYesRegistration">{{'Submit' |
                  translate}}</button>
                <button id="submit_btn" class="btn btn-medium" *ngIf="isFromCnamgsYesRegistration"
                  (click)="closeModal()">{{'Close' | translate}}</button>

                <!-- CNSS Registration Flow -->
                <button (click)="submitEmployees()" id="submit_btn" class="btn btn-medium"
                  *ngIf="isFromNoCnssRegistration">{{'Submit' |
                  translate}}</button>
                <button id="submit_btn" class="btn btn-medium" *ngIf="isFromNoCnssRegistration"
                  (click)="closeModal()">{{'Close' | translate}}</button>

                <!-- CNAMGS Registration Flow -->
                <button (click)="submitEmployees()" id="submit_btn" class="btn btn-medium"
                  *ngIf="isFromNoCnamgsRegistration">{{'Submit' | translate}}</button>
                <button id="submit_btn" class="btn btn-medium" *ngIf="isFromNoCnamgsRegistration"
                  (click)="closeModal()">{{'Close' | translate}}</button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Employees added success modal -->
<section class="modal-section2">
  <div class="modal fade" id="addEmployeeSuccessModal" data-backdrop="true" data-keyboard="false" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="parent">
            <div class="image-container">
              <img src="assets/images/Link-sucsess.png" style="width: 50%;margin: 0 auto;display: block;">
            </div>
            <div class="text-container text-center">
              <h4 class="modal-header-txt">{{'Congratulations!' | translate}}</h4>
              <p class="para-light">{{'We acknowledge receipt of the insured persons you declare. We will study your declaration with a view to activating their CCPS identifier.' | translate}}</p>
              <button id="submit_btn" class="btn btn-medium" data-dismiss="modal" (click)="closeSuccessModal()">{{'OK' |
                translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--bulk upload success modal -->
<section class="modal-section2 bulk-upload-modal">
  <div class="modal fade" id="bulkUploadSuccesssModal" data-backdrop="true" data-keyboard="false" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <!-- <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button> -->
        <div class="modal-body">
          <div class="parent-container">
            <h5 *ngIf="showSuccessTitle" class="form-title text-center">{{'List of Employees Successfully Added' |
              translate}}</h5>
            <div class="text-container text-center">
            </div>
            <section class="quiz_section" id="quizeSection">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12" *ngFor="let success of bulkUploadSuccess">
                    <div class="quiz_card_area">
                      <div class="single_quiz_card bulksuccess">
                        <div class="quiz_card_content">
                          <div class="quiz_card_title ">
                            <h3><i class="fa fa-check" aria-hidden="true"></i>{{ success.firstname }} {{
                              success.lastname }}</h3>
                          </div>
                          <div class="quiz_card_icon">
                            <div class="row">
                              <div class="col-md-6">
                                <div class="d-flex align-items-center justify-content-center">
                                  <label>{{'Date of Birth' | translate }} :</label>
                                  <h3>{{ success.dob }}</h3>
                                </div>
                                <div class="d-flex align-items-center justify-content-center">
                                  <label>{{'Designation' | translate }} :</label>
                                  <h3>{{ success.designation }}</h3>
                                </div>
                                <div class="d-flex align-items-center justify-content-center">
                                  <label>{{'CNAMGS ID' | translate }} :</label>
                                  <h3 *ngIf="success.cnamgs">{{ success.cnamgs }}</h3>
                                  <h3 *ngIf="!success.cnamgs">--</h3>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="d-flex align-items-center justify-content-center">
                                  <label>{{'CNSS ID' | translate}} :</label>
                                  <h3 *ngIf="success.cnss">{{ success.cnss }}</h3>
                                  <h3 *ngIf="!success.cnss">--</h3>
                                </div>
                                <div class="d-flex align-items-center justify-content-center">
                                  <label>{{'Mobile' | translate}} :</label>
                                  <h3>{{ success.mobile }}</h3>
                                </div>
                              </div>
                            </div>
                            <div class="salary-list-section ">
                              <div class="salary-list-head-section">
                                <h4>{{'Salary List' | translate}}</h4>
                                <div class="table-head-section green">
                                  <h5>{{'Month' | translate}}</h5>
                                  <h5>{{'Amount' | translate}} (FCFA)</h5>
                                </div>
                              </div>
                              <div class="salary-list-body-section green">
                                <div class="salary-list-body-item" *ngFor="let s of success.salary">
                                  <h5>{{ s.month | translate }}</h5>
                                  <h5>{{ s.amount }}</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </section>
            <h5 *ngIf="showFailedTitle" class="form-title text-center">{{'List of Employees Failed to Add' | translate}}
            </h5>
            <section class="quiz_section" id="quizeSection">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12" *ngFor="let failed of bulkUploadFailed">
                    <div class="quiz_card_area">
                      <div class="single_quiz_card bulkfailed">
                        <div class="quiz_card_content">
                          <div class="quiz_card_title ">
                            <h3><i class="fa fa-check" aria-hidden="true"></i>{{ failed.firstname }} {{ failed.lastname
                              }}</h3>
                          </div>
                          <div class="quiz_card_icon">
                            <div class="row">
                              <div class="col-md-6">
                                <div class="d-flex align-items-center justify-content-center">
                                  <label>{{'Name of Employee' | translate }} :</label>
                                  <h3>{{ failed.name }}</h3>
                                  <h3 *ngIf="!failed.name">--</h3>
                                </div>
                                <div class="d-flex align-items-center justify-content-center">
                                  <label>{{'Date of Birth' | translate }} :</label>
                                  <h3>{{ failed.dob }}</h3>
                                  <h3 *ngIf="!failed.dob">--</h3>
                                </div>
                                <div class="d-flex align-items-center justify-content-center">
                                  <label>{{'Designation' | translate }} :</label>
                                  <h3>{{ failed.designation }}</h3>
                                  <h3 *ngIf="!failed.designation">--</h3>
                                </div>
                                <!-- <div class="d-flex align-items-center justify-content-center">
                                  <label>{{'CNAMGS ID' | translate }} :</label>
                                  <h3 *ngIf="failed.cnamgs">{{ failed.cnamgs }}</h3>
                                  <h3 *ngIf="!failed.cnamgs">--</h3>
                                </div> -->
                              </div>
                              <div class="col-md-6">
                                <div class="d-flex align-items-center justify-content-center">
                                  <label>{{'CNAMGS ID' | translate }} :</label>
                                  <h3 *ngIf="failed.cnamgs">{{ failed.cnamgs }}</h3>
                                  <h3 *ngIf="!failed.cnamgs">--</h3>
                                </div>
                                <div class="d-flex align-items-center justify-content-center">
                                  <label>{{'CNSS ID' | translate}} :</label>
                                  <h3 *ngIf="failed.cnss">{{ failed.cnss }}</h3>
                                  <h3 *ngIf="!failed.cnss">--</h3>
                                </div>
                                <div class="d-flex align-items-center justify-content-center">
                                  <label>{{'Mobile' | translate}} :</label>
                                  <h3>{{ failed.mobile }}</h3>
                                  <h3 *ngIf="!failed.mobile">--</h3>
                                </div>

                              </div>
                            </div>
                            <div class="salary-list-section">
                              <div class="salary-list-head-section">
                                <h4>{{'Salary List' | translate}}</h4>
                                <div class="table-head-section">
                                  <h5>{{'Month' | translate}}</h5>
                                  <h5>{{'Amount' | translate}} (FCFA)</h5>
                                </div>
                              </div>
                              <div class="salary-list-body-section">
                                <div class="salary-list-body-item" *ngFor="let s of failed.salary">
                                  <h5>{{ s.month | translate }}</h5>
                                  <h5>{{ s.amount }}</h5>
                                </div>
                                <div class="no-data-section " *ngIf="failed.salary.length == 0">
                                  <h5>{{'No data found' | translate}}</h5>
                                </div>
                              </div>
                            </div>


                          </div>
                        </div>
                      </div>
                      <div *ngFor="let reason of failed.reasons; let i = index "
                        class="reason-txt invalid-feedback text-center">* {{reason}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex buttons">
                <button (click)="closeModal('1'); showPendingEmployees();" id="submit_btn" class="btn btn-medium">{{'OK'
                  | translate}}</button>
                <button (click)="reuploadPayrollFile()" class="btn btn-medium">{{'Reupload payroll file' |
                  translate}}</button>

              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div id="resignation-confirm-modal" class="modal fade rejectcalculate" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <!-- Modal content-->
    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal">&times;</button>
      <div class="modal-body">
        <h5>{{'Are you sure you want to end this employment relationship' | translate}}</h5>
        <div class="buttonFlex">
          <button class="reject_color" data-dismiss="modal">{{'No' | translate}}</button>
          <button type="submit" form="employeeResignForm" class="accept_color">{{'Yes' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Employees added  success modal  end-->
<app-contact-floating></app-contact-floating>



<div class="modal fade" id="reportModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{'Select year and quarter'| translate}}</h5>
        <!-- <h5 class="modal-title" id="exampleModalLongTitle" *ngIf="page">{{'Initiate CNAMGS Reports'| translate}}</h5> -->
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate"
          (click)="closeGenrateReport()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <form class="form-container" [formGroup]="contactForm">
          <div class="parent datepicker-container">
            <!--     <label for="">{{'Select Year'| translate}}</label>
           <select class="form-select form-select-lg mb-3" aria-label=".form-select-lg example" formControlName="year">
              <option value="2022" selected="selected">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
            </select> -->
            <div class="input-container" [owlDateTimeTrigger]="dt460">
              <input class="custom-input text-center" name="year" readonly formControlName="year">
              <label for="">{{'Select Year'| translate}}</label>
              <div class="date-field">
                <input [owlDateTime]="dt460" name="service_start_date" [min]="minReportDate" [max]="todayDate" readonly>
                <div class="calendar input-group-prepend">
                  <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                </div>
              </div>
              <owl-date-time [pickerType]="'calendar'" [startView]="'multi-years'"
                (yearSelected)="chosenYearHandler($event)" #dt460></owl-date-time>
            </div>
            <div class="parent">
              <label for="">{{'Select Quarter'| translate}}</label>
              <select class="form-select form-select-lg mb-3" aria-label=".form-select-lg example"
                formControlName="quarter">
                <option value="1" selected>{{'One'| translate}}</option>
                <option value="2">{{'Two'| translate}}</option>
                <option value="3">{{'Three'| translate}}</option>
                <option value="4">{{'Four'| translate}}</option>
              </select>
            </div>
            <button id="submit_btn" type="button" class="btn btn-medium" (click)="onBulkUploadNext()">{{'Next'|
              translate}}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="companyNotFoundModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">
    <div class="modal-content">
      <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body">
          <div class="verify-nif-modal-content text-center">
              <img [src]="isSuccessModal ? 'assets/images/valid.png' : 'assets/images/resub.png'" alt="" class="not-found-img">
              <h2 class="modal-title mb-2">{{modalHeading | translate}}</h2>

              <p class="modal-description text-center">{{modalDescription | translate}}</p>
              <div class="btn-yes-no">
                  <button class="yes-btn" data-dismiss="modal" >{{'Close' | translate}}</button>
                  
              </div>
          </div>
       
      </div>
    </div>
  </div>
</div>

